<template>
  <div>
    <h2 class="ViewHeading" v-if="this.deviceType == 'O1'">O-1 Trend Report</h2>
    <h2 class="ViewHeading" v-if="this.deviceType == 'C1'">C-1 Trend Report</h2>

    <b-button variant="outline-secondary" size="sm" v-on:click="backButton()">
      <BIconArrowLeftSquare variant="dark"> </BIconArrowLeftSquare>
      Back
    </b-button>
    <br id="excelBR" />
    <br />

    <br />
    <div v-if="deviceType == 'C1' || deviceType == 'O1' || deviceType == 'HW'">
      <b-jumbotron>
        <section
          v-if="(this.fromSubGroup == false) & (this.deviceType == 'C1')"
        >
          <b-row>
            <b-col class="centered" cols="3">
              <b-col>
                <BIconTabletLandscape scale="2"></BIconTabletLandscape>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="DeviceID">Device</label>

              <p id="DeviceID">{{ this.HumanName }}</p>
            </b-col>
            <b-col class="centered" cols="3">
              <b-col>
                <BIconPinMap scale="2"></BIconPinMap>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="Location">Location</label>
              <p id="Location">{{ this.deviceLocation }}</p>
            </b-col>

            <b-col class="centered" cols="3">
              <b-col>
                <BIconPin scale="2"></BIconPin>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="Position">Position</label>
              <p id="Position">{{ this.devicePosition }}</p>
            </b-col>
            <b-col class="centered" cols="3">
              <b-col>
                <BIconGraphUp scale="2"></BIconGraphUp>
              </b-col>
              <b-col></b-col>
              <label
                class="headerText"
                for="RiskState"
                >Current Risk Level</label
              >
              <!-- <label
                v-if="IfMultipipe == true"
                class="headerText"
                for="RiskState"
                >Current Risk Level</label
              > -->

              <p id="RiskState">{{ this.deviceRiskLevel }}</p>
            </b-col>
          </b-row>
          <hr />
          <b-card
            bg-variant="transparent"
            border-variant="transparent"
            text-variant="dark"
            title=""
            class="NoCardBorder"
            align="center"
          >
            <b-card-sub-title class="mb-2">
 
              {{c1DeviceInfo.Location}}
              <br />
              {{ c1DeviceInfo.Department }}
            </b-card-sub-title>

            <b-card-group deck>
               <b-card
                :header-bg-variant="c1DeviceInfo.Probe1ScoreVariant"
                align="center">
                <template #header>
                <b-row>
                <b-col>Probe 1</b-col>
                <b-col v-if="c1DeviceInfo.Probe1Active == 'TRUE'">{{ c1DeviceInfo.Probe1Tag }}</b-col>
                <b-col v-if="c1DeviceInfo.Probe1Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
                <b-row no-gutters>
                <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
              </b-row>
               <b-row no-gutters align-v="center">
                <b-col cols="2" align-self="center"
              ><b-avatar
                class="coldicon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe1Feed == 'Cold Feed') &
                    (c1DeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Cold Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="hoticon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe1Feed == 'Hot Feed') &
                    (c1DeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="mixedicon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe1Feed == 'Mixed Feed') &
                    (c1DeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="returnicon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe1Feed == 'Return Feed') &
                    (c1DeviceInfo.Probe1Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              ><b-avatar
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant="light"
              >
                {{ c1DeviceInfo.Probe1TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant="light"
              >
                {{ c1DeviceInfo.Probe1TempMin }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                rounded
                :class="c1DeviceInfo.Probe1TempVariant"
                >{{ c1DeviceInfo.Probe1AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="c1DeviceInfo.Probe1Active == 'TRUE'"
                  :class="c1DeviceInfo.Probe1FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="c1DeviceInfo.Probe1Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
              <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe1TimeSinceLastFlow != 'N/A' &&
                  c1DeviceInfo.Probe1Active == 'TRUE'
              "
              >{{ c1DeviceInfo.Probe1TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe1TimeSinceLastFlow == 'N/A' ||
                  c1DeviceInfo.Probe1Active != 'TRUE'
              "
              >N/A</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
              <b-col align-self="center"><b-progress :value="c1DeviceInfo.Probe1BioLevel" max=5 :variant="c1DeviceInfo.Probe1BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
              </b-row>
                </b-card>
               <b-card
                :header-bg-variant="c1DeviceInfo.Probe2ScoreVariant"
                align="center">
                <template #header>
                <b-row>
                <b-col>Probe 2</b-col>
                <b-col v-if="c1DeviceInfo.Probe2Active == 'TRUE'">{{ c1DeviceInfo.Probe2Tag }}</b-col>
                <b-col v-if="c1DeviceInfo.Probe2Active != 'TRUE'">Inactive</b-col></b-row>
            </template>
                <b-row no-gutters>
                <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                <b-col cols="2"><p class="cardhead">Max</p></b-col>
                <b-col cols="2"><p class="cardhead">Min</p></b-col>
                <b-col cols="2"><p class="cardhead">Avg</p></b-col>
                <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
              </b-row>
              <b-row no-gutters align-v="center">
                <b-col cols="2" align-self="center"
              ><b-avatar
                class="coldicon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe2Feed == 'Cold Feed') &
                    (c1DeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Cold Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="hoticon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe2Feed == 'Hot Feed') &
                    (c1DeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Hot Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="mixedicon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe2Feed == 'Mixed Feed') &
                    (c1DeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Mixed Feed"
                ><BIconDropletHalf></BIconDropletHalf
              ></b-avatar>
              <b-avatar
                class="returnicon"
                size="2.5rem"
                rounded
                v-if="
                  (c1DeviceInfo.Probe2Feed == 'Return Feed') &
                    (c1DeviceInfo.Probe2Active == 'TRUE')
                "
                v-b-tooltip.hover
                title="Return Pipe"
                >R</b-avatar
              ><b-avatar
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
               <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant="light"
              >
                {{ c1DeviceInfo.Probe2TempLimit }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                size="2.5rem"
                rounded
                variant="light"
              >
                {{ c1DeviceInfo.Probe2TempMin }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                size="2.5em"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2"
              ><b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                rounded
                :class="c1DeviceInfo.Probe2TempVariant"
                >{{ c1DeviceInfo.Probe2AvgTempRounded }}<p class="small">&#8451;</p></b-avatar>
              <b-avatar
                size="2.5em"
                v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                rounded
                variant="light"
                >--</b-avatar></b-col>
              <b-col cols="2">
                <b-avatar
                  size="2.5em"
                  rounded
                  v-if="c1DeviceInfo.Probe2Active == 'TRUE'"
                  :class="c1DeviceInfo.Probe2FlowVariant"
                  ><BIconWater font-scale="1.5"></BIconWater
                ></b-avatar>
                <b-avatar
                  size="2.5em"
                  v-if="c1DeviceInfo.Probe2Active != 'TRUE'"
                  rounded
                  variant="light"
                  >--</b-avatar></b-col>
              <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe2TimeSinceLastFlow != 'N/A' &&
                  c1DeviceInfo.Probe2Active == 'TRUE'
              "
              >{{ c1DeviceInfo.Probe2TimeSinceLastFlow }} hrs</b-col
            >
            <b-col
              cols="2"
              v-if="
                c1DeviceInfo.Probe2TimeSinceLastFlow == 'N/A' ||
                  c1DeviceInfo.Probe2Active != 'TRUE'
              "
              >N/A</b-col>
            </b-row>
            <br/>
            <b-row>
              <b-col cols="4" align-self="end"><p class="smalltag">Biofilm Risk:</p></b-col>
              <b-col align-self="center"><b-progress :value="c1DeviceInfo.Probe2BioLevel" max=5 :variant="c1DeviceInfo.Probe2BioVariant" key="Biofilm Risk" precision="2" show-value></b-progress></b-col>
            </b-row>
                </b-card>
              </b-card-group>
              </b-card>
                <!-- <b-col>

                  <b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.FlowRead != 'N/A'">
                      {{ c1DeviceInfo.FlowRead }} hours ago
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.FlowRead == 'N/A'">
                      {{ c1DeviceInfo.FlowRead }}
                    </p>
                  </b-card></b-col
                >
                <b-col
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    >
                    this card
                    <p class="cardbody">
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead == '1'"
                        variant="success"
                        >Level 1</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead == '2'"
                        variant="warning"
                        >Level 2</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead == '3'"
                        variant="warning"
                        >Level 3</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead == '4'"
                        class="highRisk"
                        >Level 4</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead == '5'"
                        variant="danger"
                        >Level 5</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead == 'NoBio'"
                        variant="info"
                        >No Data</b-badge
                      >
                    </p></b-card
                  ></b-col
                ></b-row
              >
              <b-row
                ><b-col><br /></b-col
              ></b-row>
              <b-row
                ><b-col><p class="cardhead">Min</p></b-col
                ><b-col><p class="cardhead">Max</p></b-col
                ><b-col><p class="cardhead">Avg</p></b-col></b-row
              >
              <b-row
                ><b-col class=""
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.TempLo == 'N/A'">
                      {{ c1DeviceInfo.TempLo }}
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.TempLo != 'N/A'">
                      {{ c1DeviceInfo.TempLo }}&#8451;
                    </p>
                  </b-card></b-col
                ><b-col class=""
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.TempHi == 'N/A'">
                      {{ c1DeviceInfo.TempHi }}
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.TempHi != 'N/A'">
                      {{ c1DeviceInfo.TempHi }}&#8451;
                    </p></b-card
                  ></b-col
                ><b-col class=""
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.TempMed == 'N/A'">
                      {{ c1DeviceInfo.TempMed }}
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.TempMed != 'N/A'">
                      {{ c1DeviceInfo.TempMed }}&#8451;
                    </p></b-card
                  ></b-col
                ></b-row
              >
            </b-col>
            <b-col v-if="IfMultipipe == true">
              <b-row
                ><b-col><p class="cardhead">Flow Event</p></b-col
                ><b-col><p class="cardhead">Biofilm Risk</p></b-col></b-row
              >
              <b-row>
                <b-col
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.FlowRead != 'N/A'">
                      {{ c1DeviceInfo.FlowRead }} hours ago
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.FlowRead == 'N/A'">
                      {{ c1DeviceInfo.FlowRead }}
                    </p>
                  </b-card></b-col
                >
                <b-col
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody">
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead2 == '1'"
                        variant="success"
                        >Level 1</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead2 == '2'"
                        variant="warning"
                        >Level 2</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead2 == '3'"
                        variant="warning"
                        >Level 3</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead2 == '4'"
                        class="highRisk"
                        >Level 4</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead2 == '5'"
                        variant="danger"
                        >Level 5</b-badge
                      >
                      <b-badge
                        v-if="c1DeviceInfo.PathogenRead2 == 'NoBio'"
                        variant="info"
                        >No Data</b-badge
                      >
                    </p></b-card
                  ></b-col
                ></b-row
              >
              <b-row
                ><b-col><br /></b-col
              ></b-row>
              <b-row
                ><b-col><p class="cardhead">Min</p></b-col
                ><b-col><p class="cardhead">Max</p></b-col
                ><b-col><p class="cardhead">Avg</p></b-col></b-row
              >
              <b-row
                ><b-col class=""
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.TempLo2 == 'N/A'">
                      {{ c1DeviceInfo.TempLo2 }}
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.TempLo2 != 'N/A'">
                      {{ c1DeviceInfo.TempLo2 }}&#8451;
                    </p>
                  </b-card></b-col
                ><b-col class=""
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.TempHi2 == 'N/A'">
                      {{ c1DeviceInfo.TempHi2 }}
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.TempHi2 != 'N/A'">
                      {{ c1DeviceInfo.TempHi2 }}&#8451;
                    </p></b-card
                  ></b-col
                ><b-col class=""
                  ><b-card
                    class="border border-secondary"
                    bg-variant="transparent"
                    ><p class="cardbody" v-if="c1DeviceInfo.TempMed2 == 'N/A'">
                      {{ c1DeviceInfo.TempMed2 }}
                    </p>
                    <p class="cardbody" v-if="c1DeviceInfo.TempMed2 != 'N/A'">
                      {{ c1DeviceInfo.TempMed2 }}&#8451;
                    </p></b-card
                  ></b-col
                ></b-row
              >
            </b-col>
          </b-row> -->
        </section>
        <section
          v-if="(this.fromSubGroup == false) & (this.deviceType == 'O1')"
        >
          <b-row v-if="this.screenWidth > 1000">
            <b-col class="centered" cols="3">
              <b-col>
                <BIconTabletLandscape scale="2"></BIconTabletLandscape>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="DeviceID">Device</label>

              <p id="DeviceID">{{ getNewName(this.DeviceID) }}</p>
            </b-col>
            <b-col class="centered" cols="3">
              <b-col>
                <BIconPinMap scale="2"></BIconPinMap>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="Location">Location</label>
              <p id="Location">{{ this.deviceLocation }}</p>
            </b-col>
            <b-col class="centered" cols="3">
              <b-col>
                <BIconPin scale="2"></BIconPin>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="Position">Position</label>
              <p id="Position">{{ this.deviceInformation[5] }}</p>
            </b-col>
            <b-col class="centered" cols="3">
              <b-col>
                <BIconGraphUp scale="2"></BIconGraphUp>
              </b-col>
              <b-col></b-col>
              <label class="headerText" for="RiskState"
                >Current Risk Level</label
              >
              <p id="RiskState">{{ this.deviceRiskLevel }}</p>
            </b-col>
          </b-row>

          <span v-if="this.screenWidth < 1000">
            <b-row>
              <b-col class="centered">
                <b-col>
                  <BIconTabletLandscape scale="2"></BIconTabletLandscape>
                </b-col>
                <b-col></b-col>
                <label class="headerText" for="DeviceID">Device</label>

                <p id="DeviceID">{{ this.DeviceID }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="centered">
                <b-col>
                  <BIconPinMap scale="2"></BIconPinMap>
                </b-col>
                <b-col></b-col>
                <label class="headerText" for="Location">Location</label>
                <p id="Location">{{ this.deviceLocation }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="centered">
                <b-col>
                  <BIconPin scale="2"></BIconPin>
                </b-col>
                <b-col></b-col>
                <label class="headerText" for="Position">Position</label>
                <p id="Position">{{ this.deviceInformation[5] }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="centered">
                <b-col>
                  <BIconGraphUp scale="2"></BIconGraphUp>
                </b-col>
                <b-col></b-col>
                <label class="headerText" for="RiskState"
                  >Current Risk Level</label
                >
                <p id="RiskState">{{ this.deviceRiskLevel }}</p>
              </b-col>
            </b-row>
          </span>
          <hr />

          <b-card
            bg-variant="transparent"
            border-variant="transparent"
            text-variant="dark"
            title=""
            class="NoCardBorder"
            align="center"
          >
            <b-card-sub-title class="mb-2">
 
              {{ this.deviceInformation[2] }}
              <br />
              {{ this.deviceInformation[3] }}
            </b-card-sub-title>

            <b-card-group deck v-if="ShowFurtherO1Detail == true">

              <hr />
              <b-card
                :header-bg-variant="furtherDeviceInfo[0].Probe1ScoreVariant"
                align="center"
                ><template #header>Probe 1</template>
                <b-row no-gutters>
                  <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                  <b-col cols="2"><p class="cardhead">Max</p></b-col>
                  <b-col cols="2"><p class="cardhead">Min</p></b-col>
                  <b-col cols="2"><p class="cardhead">Avg</p></b-col>
                  <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                  <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
                </b-row>
                <b-row no-gutters align-v="center">
                  <b-col cols="2" align-self="center"
                    ><b-avatar
                      class="coldicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe1Feed == 'Cold Feed') &
                          (furtherDeviceInfo[0].Probe1Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Cold Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="hoticon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe1Feed == 'Hot Feed') &
                          (furtherDeviceInfo[0].Probe1Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Hot Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="mixedicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe1Feed == 'Mixed Feed') &
                          (furtherDeviceInfo[0].Probe1Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Mixed Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="returnicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe1Feed == 'Return Feed') &
                          (furtherDeviceInfo[0].Probe1Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Return Pipe"
                      >R</b-avatar
                    ><b-avatar
                      v-if="furtherDeviceInfo[0].Probe1Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe1Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{
                        furtherDeviceInfo[0].Probe1TempLimit
                      }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe1Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe1Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{ furtherDeviceInfo[0].Probe1TempMin }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe1Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe1Active == 'TRUE'"
                      rounded
                      :class="furtherDeviceInfo[0].Probe1TempVariant"
                      >{{
                        furtherDeviceInfo[0].Probe1AvgTempRounded
                      }}<p class="small">&#8451;</p></b-avatar
                    >
                    <b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe1Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><span class="FlowIconRight">
                      <b-avatar
                        size="2.5em"
                        rounded
                        v-if="furtherDeviceInfo[0].Probe1Active == 'TRUE'"
                        :class="furtherDeviceInfo[0].Probe1FlowVariant"
                        ><BIconWater font-scale="1.5"></BIconWater
                      ></b-avatar>
                      <b-avatar
                        size="2.5em"
                        v-if="furtherDeviceInfo[0].Probe1Active != 'TRUE'"
                        rounded
                        variant="light"
                        >--</b-avatar
                      >
                    </span></b-col
                  >

                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe1TimeSinceLastFlow != 'N/A' &&
                        furtherDeviceInfo[0].Probe1Active == 'TRUE'
                    "
                    >{{
                      furtherDeviceInfo[0].Probe1TimeSinceLastFlow
                    }}
                    hrs</b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe1TimeSinceLastFlow == 'N/A' ||
                        furtherDeviceInfo[0].Probe1Active != 'TRUE'
                    "
                    >N/A</b-col
                  >
                </b-row></b-card
              >
              <br />
              <b-card
                :header-bg-variant="furtherDeviceInfo[0].Probe2ScoreVariant"
                align="center"
                ><template #header>Probe 2</template>
                <b-row no-gutters>
                  <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                  <b-col cols="2"><p class="cardhead">Max</p></b-col>
                   <b-col cols="2"><p class="cardhead">Min</p></b-col>
                  <b-col cols="2"><p class="cardhead">Avg</p></b-col>
                  <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                  <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
                </b-row>
                <b-row no-gutters align-v="center">
                  <b-col cols="2" align-self="center"
                    ><b-avatar
                      class="coldicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe2Feed == 'Cold Feed') &
                          (furtherDeviceInfo[0].Probe2Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Cold Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="hoticon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe2Feed == 'Hot Feed') &
                          (furtherDeviceInfo[0].Probe2Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Hot Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="mixedicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe2Feed == 'Mixed Feed') &
                          (furtherDeviceInfo[0].Probe2Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Mixed Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="returnicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe2Feed == 'Return Feed') &
                          (furtherDeviceInfo[0].Probe2Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Return Pipe"
                      >R</b-avatar
                    ><b-avatar
                      v-if="furtherDeviceInfo[0].Probe2Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe2Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{
                        furtherDeviceInfo[0].Probe2TempLimit
                      }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe2Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe2Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{ furtherDeviceInfo[0].Probe2TempMin }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe2Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe2Active == 'TRUE'"
                      rounded
                      :class="furtherDeviceInfo[0].Probe2TempVariant"
                      >{{
                        furtherDeviceInfo[0].Probe2AvgTempRounded
                      }}<p class="small">&#8451;</p></b-avatar
                    >
                    <b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe2Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><span class="FlowIconRight">
                      <b-avatar
                        size="2.5em"
                        rounded
                        v-if="furtherDeviceInfo[0].Probe2Active == 'TRUE'"
                        :class="furtherDeviceInfo[0].Probe2FlowVariant"
                        ><BIconWater font-scale="1.5"></BIconWater
                      ></b-avatar>
                      <b-avatar
                        size="2.5em"
                        v-if="furtherDeviceInfo[0].Probe2Active != 'TRUE'"
                        rounded
                        variant="light"
                        >--</b-avatar
                      >
                    </span></b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe2TimeSinceLastFlow != 'N/A' &&
                        furtherDeviceInfo[0].Probe2Active == 'TRUE'
                    "
                    >{{
                      furtherDeviceInfo[0].Probe2TimeSinceLastFlow
                    }}
                    hrs</b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe2TimeSinceLastFlow == 'N/A' ||
                        furtherDeviceInfo[0].Probe2Active != 'TRUE'
                    "
                    >N/A</b-col
                  >
                </b-row></b-card
              >
              <br />
            </b-card-group>
            <br />
            <b-card-group deck>
              <b-card
                :header-bg-variant="furtherDeviceInfo[0].Probe3ScoreVariant"
                align="center"
              >
                <template #header>Probe 3</template>
                <b-row no-gutters>
                  <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                  <b-col cols="2"><p class="cardhead">Max</p></b-col>
                  <b-col cols="2"><p class="cardhead">Min</p></b-col>
                  <b-col cols="2"><p class="cardhead">Avg</p></b-col>
                  <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                  <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
                </b-row>
                <b-row no-gutters align-v="center">
                  <b-col cols="2" align-self="center"
                    ><b-avatar
                      class="coldicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe3Feed == 'Cold Feed') &
                          (furtherDeviceInfo[0].Probe3Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Cold Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="hoticon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe3Feed == 'Hot Feed') &
                          (furtherDeviceInfo[0].Probe3Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Hot Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="mixedicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe3Feed == 'Mixed Feed') &
                          (furtherDeviceInfo[0].Probe3Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Mixed Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="returnicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe3Feed == 'Return Feed') &
                          (furtherDeviceInfo[0].Probe3Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Return Pipe"
                      >R</b-avatar
                    ><b-avatar
                      v-if="furtherDeviceInfo[0].Probe3Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe3Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{
                        furtherDeviceInfo[0].Probe3TempLimit
                      }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe3Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe3Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{ furtherDeviceInfo[0].Probe3TempMin }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe3Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe3Active == 'TRUE'"
                      rounded
                      :class="furtherDeviceInfo[0].Probe3TempVariant"
                      >{{
                        furtherDeviceInfo[0].Probe3AvgTempRounded
                      }}<p class="small">&#8451;</p></b-avatar
                    >
                    <b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe3Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><span class="FlowIconRight">
                      <b-avatar
                        size="2.5em"
                        rounded
                        v-if="furtherDeviceInfo[0].Probe3Active == 'TRUE'"
                        :class="furtherDeviceInfo[0].Probe3FlowVariant"
                        ><BIconWater font-scale="1.5"></BIconWater
                      ></b-avatar>
                      <b-avatar
                        size="2.5em"
                        v-if="furtherDeviceInfo[0].Probe3Active != 'TRUE'"
                        rounded
                        variant="light"
                        >--</b-avatar
                      >
                    </span></b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe3TimeSinceLastFlow != 'N/A' &&
                        furtherDeviceInfo[0].Probe3Active == 'TRUE'
                    "
                    >{{
                      furtherDeviceInfo[0].Probe3TimeSinceLastFlow
                    }}
                    hrs</b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe3TimeSinceLastFlow == 'N/A' ||
                        furtherDeviceInfo[0].Probe3Active != 'TRUE'
                    "
                    >N/A</b-col
                  >
                </b-row></b-card
              >
              <br />
              <b-card
                :header-bg-variant="furtherDeviceInfo[0].Probe4ScoreVariant"
                align="center"
                ><template #header>Probe 4</template>
                <b-row no-gutters>
                  <b-col cols="2"><p class="cardhead">Feed</p></b-col>
                  <b-col cols="2"><p class="cardhead">Max</p></b-col>
                  <b-col cols="2"><p class="cardhead">Min</p></b-col>
                  <b-col cols="2"><p class="cardhead">Avg</p></b-col>
                  <b-col cols="2"><p class="cardhead">Flow</p></b-col>
                  <b-col cols="2"><p class="cardhead">Last Flow</p></b-col>
                </b-row>
                <b-row no-gutters align-v="center">
                  <b-col cols="2" align-self="center"
                    ><b-avatar
                      class="coldicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe4Feed == 'Cold Feed') &
                          (furtherDeviceInfo[0].Probe4Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Cold Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="hoticon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe4Feed == 'Hot Feed') &
                          (furtherDeviceInfo[0].Probe4Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Hot Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="mixedicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe4Feed == 'Mixed Feed') &
                          (furtherDeviceInfo[0].Probe4Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Mixed Feed"
                      ><BIconDropletHalf></BIconDropletHalf
                    ></b-avatar>
                    <b-avatar
                      class="returnicon"
                      size="2.5rem"
                      rounded
                      v-if="
                        (furtherDeviceInfo[0].Probe4Feed == 'Return Feed') &
                          (furtherDeviceInfo[0].Probe4Active == 'TRUE')
                      "
                      v-b-tooltip.hover
                      title="Return Pipe"
                      >R</b-avatar
                    ><b-avatar
                      v-if="furtherDeviceInfo[0].Probe4Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe4Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{
                        furtherDeviceInfo[0].Probe4TempLimit
                      }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe4Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  ><b-col cols="2">
                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe4Active == 'TRUE'"
                      size="2.5rem"
                      rounded
                      variant="light"
                    >
                      {{ furtherDeviceInfo[0].Probe4TempMin }}<p class="small">&#8451;</p></b-avatar
                    >

                    <b-avatar
                      v-if="furtherDeviceInfo[0].Probe4Active != 'TRUE'"
                      size="2.5em"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe4Active == 'TRUE'"
                      rounded
                      :class="furtherDeviceInfo[0].Probe4TempVariant"
                      >{{
                        furtherDeviceInfo[0].Probe4AvgTempRounded
                      }}<p class="small">&#8451;</p></b-avatar
                    >
                    <b-avatar
                      size="2.5em"
                      v-if="furtherDeviceInfo[0].Probe4Active != 'TRUE'"
                      rounded
                      variant="light"
                      >--</b-avatar
                    ></b-col
                  >
                  <b-col cols="2"
                    ><span class="FlowIconRight">
                      <b-avatar
                        size="2.5em"
                        rounded
                        v-if="furtherDeviceInfo[0].Probe4Active == 'TRUE'"
                        :class="furtherDeviceInfo[0].Probe4FlowVariant"
                        ><BIconWater font-scale="1.5"></BIconWater
                      ></b-avatar>
                      <b-avatar
                        size="2.5em"
                        v-if="furtherDeviceInfo[0].Probe4Active != 'TRUE'"
                        rounded
                        variant="light"
                        >--</b-avatar
                      >
                    </span></b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe4TimeSinceLastFlow != 'N/A' &&
                        furtherDeviceInfo[0].Probe4Active == 'TRUE'
                    "
                    >{{
                      furtherDeviceInfo[0].Probe4TimeSinceLastFlow
                    }}
                    hrs</b-col
                  >
                  <b-col
                    cols="2"
                    v-if="
                      furtherDeviceInfo[0].Probe4TimeSinceLastFlow == 'N/A' ||
                        furtherDeviceInfo[0].Probe4Active != 'TRUE'
                    "
                    >N/A</b-col
                  >
                </b-row></b-card
              >
            </b-card-group>
          </b-card>
        </section>
      </b-jumbotron>
<!-- 
      <b-card no-body class="mb-1"> -->
        <!-- <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="outline-info"
            >Rolling Monthly Data</b-button
          >
        </b-card-header>
        <b-collapse
          id="accordion-1"
          accordion="my-accordion"
          role="tabpanel"
          visible
          lazy
        > -->
          <!-- <b-card-body> -->
            <b-card>
              <CalendarHeatmap
                :end-date="this.GetTodaysDate()"
                :max="4"
                :range-color="[
                  'rgb(200,200,200)',
                  '#dc3545',
                  '#f05e16',
                  '#ffc107',
                  '#28a745',
                ]"
                :values="this.heatmapvalues"
              >
              </CalendarHeatmap>
            </b-card>
          <!-- </b-card-body> -->
        <!-- </b-collapse> -->
      <!-- </b-card> -->
       <br/>
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="outline-info"
            >Selectable Date Data</b-button
          >
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-row class="centered">
              <b-col cols="6">
                <label for="fromDate">From Date:</label>
                <b-form-datepicker
                  type="date"
                  v-model="FromDate"
                  id="fromDate"
                ></b-form-datepicker>
              </b-col>
              <b-col cols="6">
                <label for="toDate">To Date:</label>
                <b-form-datepicker
                  type="date"
                  v-model="ToDate"
                  id="toDate"
                ></b-form-datepicker>
              </b-col>
            </b-row>
            <br />
            <!-- <b-row v-if="this.IfMultipipe == true">
              <b-col cols="3"> </b-col>
              <b-col class="text-center"> Current Selected Pipe </b-col>
              <b-col class="text-center"> {{ this.PipeToShow }} </b-col>
              <b-col cols="3"> </b-col>
            </b-row>
            <br />
            <b-row v-if="this.IfMultipipe == true">
              <b-col class="text-center">
                <b-button v-on:click="ShowPipeModal()">
                  Select Different Pipe
                </b-button>
              </b-col>
            </b-row>
            <br /> -->
            <b-row>
              <b-col cols=""></b-col>
              <b-col cols="" class="centered">
                <b-button-group>
                  <b-button
                    variant="outline-secondary"
                    v-on:click="submitDates()"
                    >Submit</b-button
                  >
                  <b-button
                    variant="outline-secondary"
                    v-on:click="resetDates()"
                    >Reset
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col cols=""></b-col>
            </b-row>
            <hr />
            <div
              v-if="
                (this.FromDate != '') &
                  (this.ToDate != '') &
                  (this.DataToShow == true)
              "
            >
            <b-card v-if="this.deviceType == 'C1'" no-body>
            <div id="wrapper">
            <div id="Probe1" v-if="this.probe1active">
            <VueApexCharts type="line" height="200" :options="biofilmNewOptions1" :series="biofilmNewOptions1.series"></VueApexCharts>
            </div>
            <div id="Probe2" v-if="this.probe2active">
            <VueApexCharts type="line" height="190" :options="biofilmNewOptions2" :series="biofilmNewOptions2.series"></VueApexCharts>
            </div>
            </div>
                </b-card>
                <br/>
              <b-card-group deck v-if="this.deviceType == 'C1'">
                
                <!-- <b-card>
                  <b-col>
                    <VueApexCharts
                      ref="C1biofilmChart"
                      type="line"
                      height="350"
                      :options="biofilmChartOptions"
                      :series="biofilmChartOptions.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card> -->
                <b-card>
                    <b-col>
                    <VueApexCharts
                      type="line"
                      height="350"
                      :options="deviceRiskChartOptions"
                      :series="deviceRiskChartOptions.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
                <b-card>
 
                  <b-col>
                    <VueApexCharts
                      type="bar"
                      height="350"
                      :options="flowChartOptions"
                      :series="flowChartOptions.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
              </b-card-group>
              <br />
              <!-- <b-card-group deck v-if="this.deviceType == 'C1'">
                <b-card>
                  <b-col>
                    <VueApexCharts
                      type="line"
                      height="350"
                      :options="chartOptions"
                      :series="chartOptions.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
                <b-card>
                  <b-col>
                    <VueApexCharts
                      type="line"
                      height="350"
                      :options="deviceRiskChartOptions"
                      :series="deviceRiskChartOptions.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
              </b-card-group> -->
              <b-card-group deck v-if="this.deviceType == 'O1'">
                <b-card>
                  <b-col>
                    <VueApexCharts
                      type="line"
                      height="350"
                      :options="O1DeviceRiskLevelChart"
                      :series="O1DeviceRiskLevelChart.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
                <b-card>
                  <b-col>
                    <VueApexCharts
                      type="bar"
                      height="350"
                      :options="O1FlowEvents"
                      :series="O1FlowEvents.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
              </b-card-group>
              <br />
              <b-card>
                <VueApexCharts type="rangeArea" height="350" :options="tempRangeOptions" :series="tempRangeOptions.series"></VueApexCharts>
              </b-card>
              <br />

              <!-- <b-card-group deck v-if="this.deviceType == 'O1'">
                <b-card>
                  <b-col>
                    <VueApexCharts
                      type="line"
                      height="350"
                      :options="O1TempOptions"
                      :series="O1TempOptions.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
              </b-card-group> -->
              <br />
              <!-- <b-card-group deck v-if="this.deviceType == 'O1' || 'C1'">
                <b-card>
                  <b-row>
                    <b-col>
                      Select Date For 24h Detailed Temperature Graph
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-form-datepicker
                        type="date"
                        :min="FromDate"
                        :max="ToDate"
                        v-model="DetailedDate"
                        id="DetailedDate"
                      ></b-form-datepicker>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col> -->
                      <!-- <b-button
                        variant="outline-info"
                        :disabled="loading"
                        v-on:click="getChartPreSignedURL()"
                      >
                        Generate Graph </b-button
                      >                      <b-button
                        variant="outline-info"
                        :disabled="loading"
                        v-on:click="NewChartTest()"
                      >
                        New Graph </b-button
                      ><b-button
                        variant="outline-info"
                        v-on:click="clearChart()"
                        >Clear</b-button
                      >
                    </b-col>
                  </b-row>
                  <br /> -->
                  <!-- <b-card>
                    New Graph Here Please
                  </b-card>
                  <h5 v-if="this.S3ImageURL == ''">
                    Please select a date above to generate this graph
                  </h5>
                  <div v-if="this.S3ImageURL !== ''">
                    <img alt="ReadingsChart" :src="S3ImageURL" />
                  </div>
                </b-card>

              </b-card-group> -->
              <!-- <b-card-group deck v-if="this.deviceType == 'HW'">
                <b-card>
                  <b-col>
                    HW Chart 1
                    <VueApexCharts
                      type="line"
                      height="350"
                      :options="O1DeviceRiskLevelChart"
                      :series="O1DeviceRiskLevelChart.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
                <b-card>
                  HW CHart2
                  <b-col>
                    <VueApexCharts
                      type="bar"
                      height="350"
                      :options="O1FlowEvents"
                      :series="O1FlowEvents.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
              </b-card-group>
              <br />
              <b-card-group deck v-if="this.deviceType == 'HW'">
                <b-card>
                  HW Chart3
                  <b-col>
                    <VueApexCharts
                      type="bar"
                      height="350"
                      :options="O1FlowEvents"
                      :series="O1FlowEvents.series"
                    ></VueApexCharts>
                  </b-col>
                </b-card>
              </b-card-group> -->

              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle.accordion-5 variant="outline-info"
                    >View Raw Data</b-button
                  >
                </b-card-header>
                <b-collapse id="accordion-5" role="tabpanel">
                  <b-card-body>
                    <div
                      v-if="
                        (this.FromDate != '') &
                          (this.ToDate != '') &
                          (this.DataToShow == true)
                      "
                    >
                      <div>
                        <b-skeleton-wrapper :loading="loaded">
                          <template #loading>
                            <b-card>
                              <b-skeleton
                                animation="fade"
                                width="85%"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="55%"
                              ></b-skeleton>
                              <b-skeleton
                                animation="fade"
                                width="70%"
                              ></b-skeleton>
                            </b-card>
                          </template>
                          <span id="TableData">
                            <b-card
                              header=""
                              class="mt-5"
                              v-for="(date, idx) in LabelDatesArray"
                              :key="idx"
                            >
                              <template #header>
                                <b-row>
                                  <h4 class="centered">
                                    Results for {{ date }}
                                  </h4>
                                  <b-col class="text-right">
                                    <b-dropdown
                                      v-if="idx == 0"
                                      variant="outline-secondary"
                                    >
                                      <template #button-content>
                                        <span>
                                          Download Data
                                        </span>
                                         <BIconDownload
                          class="exportIcon"
                          v-if="idx == 0"
                          scale="1"
                          variant="dark"
                        >
                        </BIconDownload>
                                      </template>
                                      <b-dropdown-item
                                        v-on:click="
                                          downloadCSV('TableData', 'Export')
                                        "
                                      >
                                        CSV
                                      </b-dropdown-item> 
                                      <b-dropdown-divider> </b-dropdown-divider>
                        <b-dropdown-item v-on:click="downloadPDF()">
                          PDF
                        </b-dropdown-item>
                                   </b-dropdown>
                                  </b-col>
                                </b-row>
                              </template>
                              <br />
                              <b-card-group deck v-if="deviceType == 'C1'">
                                <b-card
                                  border-variant="light"
                                  bg-variant="light"
                                  align='center'
                                >
                                  <h4>Biofilm Levels</h4>
                                   <b-row><b-col>Probe 1 Max Level</b-col><b-col>Probe 2 Max Level</b-col></b-row>
                                   <b-row><b-col v-if="BioArray[0][idx] == null">--</b-col><b-col v-if="BioArray[0][idx] != null">{{BioArray[0][idx]}}</b-col><b-col v-if="BioArray[1][idx] == null">--</b-col><b-col v-if="BioArray[1][idx] != null">{{BioArray[1][idx]}}</b-col></b-row>
                                </b-card>
                                <b-card
                                  border-variant="light"
                                  bg-variant="light"
                                  align="center"
                                >
                                  <h4>Risk Levels</h4>
                                  <b-row><b-col>Probe 1 Risk</b-col><b-col>Probe 2 Risk</b-col></b-row>
                                  <b-row><b-col v-if="RiskLevels[0] == null">--</b-col><b-col v-if="RiskLevels[0] != null">{{RiskLevels[0][date]}}</b-col><b-col v-if="RiskLevels[1] == null">--</b-col><b-col v-if="RiskLevels[1] != null">{{RiskLevels[1][date]}}</b-col></b-row>
                                </b-card>
                              </b-card-group>
                              <h4 class="">Temperatures</h4>
                                 <b-table
                                :id="'tempTable' + idx"
                                :items="TempTable[date]"
                                :fields="temperatureTableHeaders"
                                empty-text="No Device Data Available On This Date"
                                no-border-collapse
                                hover
                                show-empty
                                responsive
                                small 
                                sticky-header
                                v-if="deviceType=='O1'"></b-table> 
                              <br />
                              <b-table
                              :id="'temptable' + idx"
                              :items = "FullTemp[date]"
                              :fields = 'temptablenewheaders'
                              empty-text= "No Device Data Avilable On This Date"
                              no-border-collapse
                              hover
                              show-empty
                              responsive
                              small
                              sticky-header
                              v-if="deviceType=='C1'"></b-table>
                              <hr />
                              <br />
                              <h4 class="">Flows</h4>
                              <b-table
                                :id="'flowsTable' + idx"
                                :items="FullFlow[date]"
                                :fields="flowsTableHeaders"
                                empty-text="No Device Data Available On This Date"
                                no-border-collapse
                                hover
                                show-empty
                                responsive
                                small
                                sticky-header
                                v-if="deviceType =='C1'"
                              >
                              </b-table>
                              <b-table
                                :id="'flowsTable' + idx"
                                :items="FlowTable[date]"
                                :fields="flowsTableHeaders"
                                empty-text="No Device Data Available On This Date"
                                no-border-collapse
                                hover
                                show-empty
                                responsive
                                small
                                sticky-header
                                v-if="deviceType =='O1'"
                              >
                              </b-table>
                            </b-card>
                          </span>
                        </b-skeleton-wrapper> 
                      </div>

                      <br />

                      <br />
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
      <div
        v-if="
          (this.FromDate != '') &
            (this.ToDate != '') &
            (this.DataToShow == true)
        "
      >
        <br />
      </div>
    </div>
    <!-- <b-modal
      ref="PipeSelectionModal"
      id="PipeSelectionModal"
      title="Select Pipe"
      content-class="Modal"
      header-bg-variant="light"
      footer-bg-variant="light"
      lazy
      ok-only
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
    >
      <b-card>
        <b-row> <b-col> Please select either Pipe A or Pipe B </b-col></b-row>
        <b-row>
          <b-col
            ><b-form-select v-model="PipeToShow">
              <option value="A" select>Pipe A</option>
              <option value="B" select>Pipe B</option>
            </b-form-select>
          </b-col></b-row
        >
        <br />
        <b-row
          ><b-col>
            <b-button variant="outline-info" v-on:click="PipeConfirmed()">
              Confirm
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal> -->
  </div>
</template>
<script>
// import { TimeZoneTOUTC } from "../CustomFunctions/Timezone.js";
import { IDToHuman } from "../CustomFunctions/HumanName.js";

import "vue-calendar-heatmap/dist/vue-calendar-heatmap.css";
import { CalendarHeatmap } from "vue-calendar-heatmap/dist/vue-calendar-heatmap.common";

import axios from "axios";
import {
  BIconTabletLandscape,
  BIconPin,
  BIconPinMap,
  BIconGraphUp,
  BIconArrowLeftSquare,
  BIconDropletHalf,
  BIconWater,
  BIconDownload
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";

export default {
  computed: {},
  components: {
    BIconTabletLandscape,
    BIconPin,
    BIconPinMap,
    BIconGraphUp,
    VueApexCharts,
    BIconArrowLeftSquare,
    BIconDropletHalf,
    CalendarHeatmap,
    BIconWater,
    BIconDownload
  },

  data() {
    return {
      DeviceIDToChange: { C1: [], O1: [] },
      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
      HumanName: this.$HumanName,
      screenWidth: 0,
      heatmapvalues: [],
      RequestGraph: false,
      DetailedTempReport: "Data",
      DetailedDate: "",
      loading: true,
      deviceInformation: [],
      ShowFurtherO1Detail: false,
      furtherDeviceInfo: [],
      PipeSelected: false,
      PipeToShow: null,
      IfMultipipe: false,
      loaded: false,
      deviceRiskLevel: "",
      RiskLevelList: [],
      RiskLevelOverTime: "",
      DeviceID: "",
      DataToShow: false,
      deviceLocation: "",
      devicePosition: "",
      deviceType: "",
      LabelDatesArray: [],
      S3ImageURL: "",
      probe1active: true,
      probe2active: true,
      FullTemp: [],
      FullFlow: [],
      tempscalemax: 15,

      tempRangeOptions: {
      //   series: [{
      //         type: 'rangeArea',
      //         name: 'Probe 1 Range',
      //         data: [
      //            {
      //             x: "2022-08-30 00:00:00.000",
      //             y: [2, 4]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [2, 4]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [2, 4]
      //         }
      //         ]
      //       },
      //       {
      //         type: 'rangeArea',
      //         name: 'Probe 2 Range',
      //         data: [
      //            {
      //             x: "2022-08-30 00:00:00.000",
      //             y: [6, 8]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [6, 8]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [6, 8]
      //         }
      //         ]
      //       },     
      //       {
      //         type: 'rangeArea',
      //         name: 'Probe 3 Range',
      //         data: [
      //            {
      //             x: "2022-08-30 00:00:00.000",
      //             y: [10, 12]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [10, 12]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [10, 12]
      //         }
      //         ]
      //       }, 
      //       {
      //         type: 'rangeArea',
      //         name: 'Probe 4 Range',
      //         data: [
      //            {
      //             x: "2022-08-30 00:00:00.000",
      //             y: [14, 16]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [14, 16]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [14, 16]
      //         }
      //         ]
      //       }, 
      //       {
      //         type: 'line',
      //         name: 'Probe 1 Avg',
      //         data: [
      //            {
      //             x: "2022-08-30 00:00:00.000",
      //             y: [3]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [3]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [3]
      //         }
      //         ]
      //       },
      //       {
      //         type: 'line',
      //         name: 'Probe 2 Avg',
      //         data: [{
      //             x: "2022-08-30 00:00:00.000",
      //             y: [7]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [7]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [7]
      //         }]
      //       },
      //     {
      //         type: 'line',
      //         name: 'Probe 3 Avg',
      //         data: [{
      //             x: "2022-08-30 00:00:00.000",
      //             y: [11]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [11]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [11]
      //         }]
      //       },
      //       {
      //         type: 'line',
      //         name: 'Probe 4 Avg',
      //         data: [{
      //             x: "2022-08-30 00:00:00.000",
      //             y: [15]
      //           },
      //         {
      //           x: "2022-09-30 00:00:00.000",
      //             y: [15]
      //         },
      //         {
      //           x: "2022-10-30 00:00:00.000",
      //             y: [15]
      //         }]
      //       },
      //     ],
        
      //       chart: {
      //         height: 350,
      //         type: 'rangeArea',
      //         animations: {
      //           speed: 500
      //         }
      //       },
      //       colors: ['#d4526e','#33b2df','#f620fe','#c5ee2f','#d4526e','#33b2df','#f620fe','#c5ee2f'],
      //       dataLabels: {
      //         enabled: false
      //       },
      //       fill: {
      //         opacity: [0.24,0.24,0.24,0.24,1,1,1,1]
      //       },
      //       forecastDataPoints: {
      //         count: 2
      //       },
      //       stroke: {
      //         curve: 'straight',
      //         width: [0, 0, 2, 2]
      //       },
      //       legend: {
      //         show: true,
      //         customLegendItems: ['Probe 1', 'Probe 2','Probe 3','Probe 4'],
      //       },
      //       title: {
      //         text: 'Temperature Range'
      //       },
      //      xaxis: {
      //   type: "datetime",
      //   categories: [
      //     "2022-08-30 00:00:00.000",
      //     "2022-09-30 00:00:00.000",
      //     "2022-10-30 00:00:00.000"
      //   ],
      // },
            
      //       markers: {
      //         hover: {
      //           sizeOffset: 5
      //         }
      //       }
      },
      biofilmNewOptions1: {},
      biofilmNewOptions2: {},

      biofilmTableHeaders: [
        { key: "0", label: "Time", variant: "primary" },
        { key: "1", label: "Biofilm Level" },
      ],

      flowsTableHeaders: [
        { key: "0", label: "Time", variant: "primary" },
        { key: "1", label: "P1 Flow Detected" },
        { key: "2", label: "No. of Flows" },
        { key: "3", label: "P2 Flow Detected" },
        { key: "4", label: "No. of Flows" },
      ],

      temperatureTableHeaders: [
        { key: "0", label: "Time", variant: "primary" },
        { key: "1", label: "P1Max Temp" },
        { key: "2", label: "P1Min Temp" },
        { key: "3", label: "P1Avg Temp", tdClass: "tableClass",thClass: "tableClass"},
        { key: "4", label: "P2Max Temp" },
        { key: "5", label: "P2Min Temp" },
        { key: "6", label: "P2Avg Temp", tdClass: "tableClass",thClass: "tableClass" }, 
        { key: "7", label: "P3Max Temp" },
        { key: "8", label: "P3Min Temp" },
        { key: "9", label: "P3Avg Temp", tdClass: "tableClass",thClass: "tableClass" }, 
        { key: "10", label: "P4Max Temp" },
        { key: "11", label: "P4Min Temp" },
        { key: "12", label: "P4Avg Temp", tdClass: "tableClass",thClass: "tableClass" }
    ],
      temperatureTableData: [],
      riskLevelTableHeaders: [
        { key: "0", variant: "primary" },
        { key: "1" },
        { key: "2" },
        { key: "3" },
      ],
      riskLevelTableData: [],
      TableArray: [],
      biofilmTableData: [],
      fromSubGroup: false,
      FromDate: "",
      ToDate: "",
      O1TempOptions: {
        // series: [
        //   {
        //     name: "Probe 1",
        //     data: [44, 55, 41, 37, 22, 43, 21],
        //   },
        //   {
        //     name: "Probe 2",
        //     data: [53, 32, 33, 52, 13, 43, 32],
        //   },
        //   {
        //     name: "Probe 3",
        //     data: [12, 17, 11, 9, 15, 11, 20],
        //   },
        //   {
        //     name: "Probe 4",
        //     data: [9, 7, 5, 8, 6, 9, 4],
        //   },
        // ],
        // chart: {
        //   type: "line",
        //   stacked: false,
        //   height: 350,
        //   zoom: {
        //     enabled: false,
        //   },
        //   toolbar: {
        //     autoSelected: "zoom",
        //   },
        //   dataLabels: {
        //     enabled: false,
        //   },
        //   markers: {
        //     size: 0,
        //   },

        //   dynamicAnimation: {
        //     enabled: true,
        //     speed: 800,
        //   },
        // },
        // title: {
        //   text: "Average Temperature Over Selected Dates",
        //   align: "left",
        // },
        // stroke: {
        //   curve: "smooth",
        // },
        // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
        // xaxis: {
        //   categories: [],
        // },
        // yaxis: {},
      },

      O1DailyTempOptions: {
        // series: [
        //   {
        //     name: "Probe 1",
        //     data: [44, 55, 41, 37, 22, 43, 21],
        //   },
        //   {
        //     name: "Probe 2",
        //     data: [53, 32, 33, 52, 13, 43, 32],
        //   },
        //   {
        //     name: "Probe 3",
        //     data: [12, 17, 11, 9, 15, 11, 20],
        //   },
        //   {
        //     name: "Probe 4",
        //     data: [9, 7, 5, 8, 6, 9, 4],
        //   },
        // ],
        // chart: {
        //   type: "line",
        //   stacked: false,
        //   height: 350,
        //   zoom: {
        //     enabled: false,
        //   },
        //   toolbar: {
        //     autoSelected: "zoom",
        //   },
        //   dataLabels: {
        //     enabled: false,
        //   },
        //   markers: {
        //     size: 0,
        //   },

        //   dynamicAnimation: {
        //     enabled: true,
        //     speed: 800,
        //   },
        // },
        // title: {
        //   text: "Temperatures for given selected date",
        //   align: "left",
        // },
        // stroke: {
        //   curve: "smooth",
        // },
        // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
        // xaxis: {
        //   categories: [],
        // },
        // yaxis: {},
      },

      O1FlowEvents: {
        // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
        // colors: ["#d4526e","#33b2df","#f620fe","#c5ee2f"],
        // series: [
        //   {
        //     name: "Probe 4",
        //     data: [0],
        //   },
        // ],
        // chart: {
        //   type: "bar",
        //   height: 350,
        //   stacked: true,
        // },
        // plotOptions: {
        //   bar: {
        //     horizontal: true,
        //     dataLabels: {
        //       total: {
        //         enabled: true,
        //         offsetX: 0,
        //         style: {
        //           fontSize: "9px",
        //           fontWeight: 900,
        //         },
        //       },
        //     },
        //   },
        // },
        // stroke: {
        //   width: 1,
        //   colors: ["#fff"],
        // },
        // title: {
        //   text: "Number of Flow Events by Selected Dates ",
        // },
        // xaxis: {
        //   categories: [
        //     "Day 1",
        //     "Day 2",
        //     "Day 3",
        //     "Day 4",
        //     "Day 5",
        //     "Day 6",
        //     "Day 7",
        //   ],
        //   labels: {
        //     formatter: function(val) {
        //       let rounded = Math.round(val * 10) / 10;
        //       return rounded;
        //     },
        //   },
        // },
        // yaxis: {
        //   title: {
        //     text: undefined,
        //   },
        // },

        // fill: {
        //   opacity: 1,
        // },
        // legend: {
        //   position: "top",
        //   horizontalAlign: "left",
        //   offsetX: 40,
        // },
      },

      // rangeBarOptions: {
      //   chart: {
      //     height: 450,
      //     type: "rangeBar",
      //   },
      //   plotOptions: {
      //     bar: {
      //       horizontal: true,
      //       barHeight: "80%",
      //     },
      //   },
      //   xaxis: {
      //     type: "datetime",
      //   },
      //   stroke: {
      //     width: 1,
      //   },
      //   fill: {
      //     type: "solid",
      //     opacity: 0.6,
      //   },
      //   legend: {
      //     position: "top",
      //     horizontalAlign: "left",
      //   },
      //   series: [
      //     {
      //       name: "Bob",
      //       data: [
      //         {
      //           x: "Low risk",
      //           y: [
      //             new Date("2019-03-05").getTime(),
      //             new Date("2019-03-08").getTime(),
      //           ],
      //         },
      //         {
      //           x: "Moderate risk",
      //           y: [
      //             new Date("2019-03-02").getTime(),
      //             new Date("2019-03-05").getTime(),
      //           ],
      //         },
      //         {
      //           x: "High risk",
      //           y: [
      //             new Date("2019-03-05").getTime(),
      //             new Date("2019-03-07").getTime(),
      //           ],
      //         },
      //         {
      //           x: "Extremely high risk",
      //           y: [
      //             new Date("2019-03-03").getTime(),
      //             new Date("2019-03-09").getTime(),
      //           ],
      //         },
      //       ],
      //     },
      //   ],
      // },
      // rangeOptions: {
      //   chart: {
      //     height: 350,
      //     type: "rangeArea",
      //     animations: {
      //       speed: 500,
      //     },
      //   },
      //   colors: ["#d4526e", "#33b2df", "#d4526e", "#33b2df"],
      //   dataLabels: {
      //     enabled: false,
      //   },
      //   fill: {
      //     opacity: [0.24, 0.24, 1, 1],
      //   },
      //   forecastDataPoints: {
      //     count: 2,
      //   },
      //   stroke: {
      //     curve: "straight",
      //     width: [0, 0, 2, 2],
      //   },
      //   legend: {
      //     show: true,
      //     customLegendItems: ["Team B", "Team A"],
      //     inverseOrder: true,
      //   },
      //   title: {
      //     text: "Range Area with Forecast Line (Combo)",
      //   },
      //   markers: {
      //     hover: {
      //       sizeOffset: 5,
      //     },
      //   },

      //   series: [
      //     {
      //       type: "rangeArea",
      //       name: "Team B Range",

      //       data: [
      //         {
      //           x: "Jan",
      //           y: [1100, 1900],
      //         },
      //         {
      //           x: "Feb",
      //           y: [1200, 1800],
      //         },
      //         {
      //           x: "Mar",
      //           y: [900, 2900],
      //         },
      //         {
      //           x: "Apr",
      //           y: [1400, 2700],
      //         },
      //         {
      //           x: "May",
      //           y: [2600, 3900],
      //         },
      //         {
      //           x: "Jun",
      //           y: [500, 1700],
      //         },
      //         {
      //           x: "Jul",
      //           y: [1900, 2300],
      //         },
      //         {
      //           x: "Aug",
      //           y: [1000, 1500],
      //         },
      //       ],
      //     },

      //     {
      //       type: "rangeArea",
      //       name: "Team A Range",
      //       data: [
      //         {
      //           x: "Jan",
      //           y: [3100, 3400],
      //         },
      //         {
      //           x: "Feb",
      //           y: [4200, 5200],
      //         },
      //         {
      //           x: "Mar",
      //           y: [3900, 4900],
      //         },
      //         {
      //           x: "Apr",
      //           y: [3400, 3900],
      //         },
      //         {
      //           x: "May",
      //           y: [5100, 5900],
      //         },
      //         {
      //           x: "Jun",
      //           y: [5400, 6700],
      //         },
      //         {
      //           x: "Jul",
      //           y: [4300, 4600],
      //         },
      //         {
      //           x: "Aug",
      //           y: [2100, 2900],
      //         },
      //       ],
      //     },

      //     {
      //       type: "line",
      //       name: "Team B Median",
      //       data: [
      //         {
      //           x: "Jan",
      //           y: 1500,
      //         },
      //         {
      //           x: "Feb",
      //           y: 1700,
      //         },
      //         {
      //           x: "Mar",
      //           y: 1900,
      //         },
      //         {
      //           x: "Apr",
      //           y: 2200,
      //         },
      //         {
      //           x: "May",
      //           y: 3000,
      //         },
      //         {
      //           x: "Jun",
      //           y: 1000,
      //         },
      //         {
      //           x: "Jul",
      //           y: 2100,
      //         },
      //         {
      //           x: "Aug",
      //           y: 1200,
      //         },
      //         {
      //           x: "Sep",
      //           y: 1800,
      //         },
      //         {
      //           x: "Oct",
      //           y: 2000,
      //         },
      //       ],
      //     },
      //     {
      //       type: "line",
      //       name: "Team A Median",
      //       data: [
      //         {
      //           x: "Jan",
      //           y: 3300,
      //         },
      //         {
      //           x: "Feb",
      //           y: 4900,
      //         },
      //         {
      //           x: "Mar",
      //           y: 4300,
      //         },
      //         {
      //           x: "Apr",
      //           y: 3700,
      //         },
      //         {
      //           x: "May",
      //           y: 5500,
      //         },
      //         {
      //           x: "Jun",
      //           y: 5900,
      //         },
      //         {
      //           x: "Jul",
      //           y: 4500,
      //         },
      //         {
      //           x: "Aug",
      //           y: 2400,
      //         },
      //         {
      //           x: "Sep",
      //           y: 2100,
      //         },
      //         {
      //           x: "Oct",
      //           y: 1500,
      //         },
      //       ],
      //     },
      //   ],
      // },

      selectDeviceType: "",
      deviceTypeOptions: [
        { value: null, text: "Please select an option" },
        { value: "O1", text: "O1 device." },
        { value: "C1", text: "C1 device." },
      ],
      tableHeadersO1: [
        { key: "DeviceID", variant: "primary" },
        { key: "Time" },
        { key: "MinTemp" },
        { key: "MaxTemp" },
        { key: "AlertLevel" },
      ],


      // val: "lorem ips",

      // plotOptions: {
      //   pie: {
      //     donut: {
      //       labels: {
      //         show: true,
      //         total: {
      //           show: true,
      //           label: "",
      //           formatter: () => "Text you want",
      //         },
      //       },
      //     },
      //   },
      // },

      O1DeviceRiskLevelChart: {},

      chartOptions: {
        series: [
          {
            name: "Average (°C)",
            data: [3],
          },
        ],
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Average Temperature Over Selected Dates",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#e9ecef", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.1,
          },
        },
        markers: {
          colors: ["#fce1e4"],
        },
        colors: ["#E97451"],
        xaxis: {
          categories: [],
        },
      },
      // biofilm2: [
      //   {
      //     name: "Risk State",
      //     data: [1, 1, 3, 3, 4, 2, 2, 3, 1],
      //   },
      // ],
      // biofilmChartOptions2: {
      //   chart: {
      //     type: "line",
      //     stacked: false,
      //     height: 350,
      //     zoom: {
      //       enabled: false,
      //     },
      //     toolbar: {
      //       autoSelected: "zoom",
      //     },
      //     dataLabels: {
      //       enabled: false,
      //     },
      //     markers: {
      //       size: 0,
      //     },
      //   },
      //   title: {
      //     text: "Device Risk Over Selected Dates",
      //     align: "left",
      //   },

      //   colors: ["#808080"],
      //   xaxis: {
      //     categories: [
      //       "Jan",
      //       "Feb",
      //       "Mar",
      //       "Apr",
      //       "May",
      //       "Jun",
      //       "Jul",
      //       "Aug",
      //       "Sep",
      //     ],
      //   },
      //   yaxis: {
      //     min: 0,
      //     max: 4,
      //     tickAmount: 4,
      //     labels: {
      //       show: true,
      //       align: "right",
      //       minWidth: 0,
      //       maxWidth: 160,
      //       style: {
      //         colors: [],
      //         fontSize: "11px",
      //         fontWeight: 400,
      //         cssClass: "apexcharts-yaxis-label",
      //       },
      //       offsetX: 0,
      //       offsetY: 0,
      //       rotate: -35,
      //       formatter: function(val) {
      //         let RealNo = null;

      //         if (val == 4) {
      //           RealNo = 1;
      //         } else if (val == 3) {
      //           RealNo = 2;
      //         } else if (val == 2) {
      //           RealNo = 3;
      //         } else if (val == 1) {
      //           RealNo = 4;
      //         } else if (val == 0) {
      //           RealNo = "Stateless";
      //         }

      //         let labelID = "";
      //         if (RealNo == 4) {
      //           labelID = "Low";
      //         } else if (RealNo == 3) {
      //           labelID = "Moderate";
      //         } else if (RealNo == 2) {
      //           labelID = "High";
      //         } else if (RealNo == 1) {
      //           labelID = "Ext High";
      //         } else if (val == 0) {
      //           labelID = "Stateless";
      //         }
      //         return [labelID];
      //       },
      //     },
      //   },
      // },
      c1DeviceInfo: "",

      deviceRiskChartOptions: {},

      // biofilmChartOptions: {
      //   series: [
      //     {
      //       name: "Biofilm Level",
      //       data: [3],
      //     },
      //   ],
      //   chart: {
      //     type: "area",
      //     stacked: false,
      //     height: 350,
      //     zoom: {
      //       enabled: false,
      //     },
      //     toolbar: {
      //       autoSelected: "zoom",
      //     },
      //     dataLabels: {
      //       enabled: false,
      //     },
      //     markers: {
      //       size: 0,
      //     },

      //     dynamicAnimation: {
      //       enabled: true,
      //       speed: 800,
      //     },
      //   },
      //   title: {
      //     text: "Biofilm Level Over Selected Dates",
      //     align: "left",
      //   },
      //   stroke: {
      //     curve: "smooth",
      //   },
      //   colors: ["#5F8575"],
      //   xaxis: {
      //     categories: [],
      //   },
      //   yaxis: {
      //     min: 1,
      //     max: 5,
      //     tickAmount: 4,
      //     labels: {
      //       formatter: function(val) {
      //         let labelID = "";
      //         if (val == 1) {
      //           labelID = "Level 1";
      //         } else if (val == 2) {
      //           labelID = "Level 2";
      //         } else if (val == 3) {
      //           labelID = "Level 3";
      //         } else if (val == 4) {
      //           labelID = "Level 4";
      //         } else if (val == 5) {
      //           labelID = "Level 5";
      //         }
      //         return [labelID];
      //       },
      //     },
      //   },
      // },

      flowChartOptions: {
        // series: [
        //   {
        //     name: "No. of Flow Events",
        //     data: [3],
        //   },
        // ],
        // chart: {
        //   type: "bar",
        //   height: 350,
        // },
        // title: {
        //   text: "Number of Flow Events by Selected Dates",
        //   align: "left",
        // },
        // plotOptions: {
        //   bar: {
        //     borderRadius: 4,
        //     horizontal: true,
        //   },
        //   dataLabels: {
        //     enabled: false,
        //   },
        // },
        // xaxis: {
        //   categories: [],
        // },
      },
    };
  },

  async beforeMount() {},

  mounted() {
    this.updateScreenWidth();
    this.onScreenResize();
    let TempDevID = localStorage.getItem("DeviceID");
    if (TempDevID != null) {
      this.DeviceID = TempDevID;
    } else {
      this.DeviceID = this.$DeviceID;
    }
    localStorage.removeItem("DeviceID");

    // BELOW IS O1 OR C1 SELECTOR

    if (this.$DetailToShow == "C-1") {
      this.deviceType = "C1";
      this.IDGetArrays(this.DeviceID, this.deviceType);
      this.SwitchToHuman("C1");
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersFeed = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.DeviceID,
        Report: "C1DeviceDetail",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
        .then((response) => {
          this.loading = false;

          this.RequestGraph = false;

          let responseArray =response.data.Values

          let FlowDate = "";
          let FlowTime = "";
          let FlowTimeDate = "";
          let time = "";

          let Probe1TempVariant = '';
          let Probe1FlowVariant = '';

          FlowDate = responseArray[0][28];
          FlowTime = responseArray[0][29];

          if (responseArray[0][8] == "TRUE") {
              if (responseArray[0][28] == null || responseArray[0][29] == null) {
                time = "N/A";
                Probe1FlowVariant = "secondary";
              } else {
                FlowTimeDate = FlowDate + "T" + FlowTime;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate).getTime();
                time = Math.floor((d1 - d2) / 1000 / 60 / 60);

                if (time <= 8) {
                Probe1FlowVariant = "success";
              }
              if ((time >= 9) & (time <= 24)) {
                Probe1FlowVariant = "warning";
              }
              if ((time >= 25) & (time <= 47)) {
                Probe1FlowVariant = "warning";
              }
              if (time >= 48) {
                Probe1FlowVariant = "danger";
              }
              }
            }

           if (responseArray[0][8] == "TRUE") {
              if (responseArray[0][9] == "Cold Feed") {
                if (responseArray[0][25] <= 19.99) {
                  Probe1TempVariant = "success";
                } else if (
                  (responseArray[0][25] > 20) &
                  (responseArray[0][25] <= 24.99)
                ) {
                  Probe1TempVariant = "warning";
                } else if (responseArray[0][25] > 30) {
                  Probe1TempVariant = "danger";
                } else if (
                  (responseArray[0][25] >= 25) &
                  (responseArray[0][25] <= 29.99)
                ) {
                  Probe1TempVariant = "highRisk";
                }
              }
              if (responseArray[0][9] == "Hot Feed") {
                if ((responseArray[0][25] <= 46) & (responseArray[0][25] > 37)) {
                  Probe1TempVariant = "danger";
                } else if (
                  (responseArray[0][25] <= 37) &
                  (responseArray[0][25] >= 30)
                ) {
                  Probe1TempVariant = "highRisk";
                } else if (
                  (responseArray[0][25] >= 45.99) &
                  (responseArray[0][25] <= 49.99)
                ) {
                  Probe1TempVariant = "highRisk";
                } else if (
                  (responseArray[0][25] > 50) &
                  (responseArray[0][25] <= 54.99)
                ) {
                  Probe1TempVariant = "warning";
                } else if (responseArray[0][25] < 29.99) {
                  Probe1TempVariant = "warning";
                } else if (responseArray[0][25] > 55) {
                  Probe1TempVariant = "success";
                }
              }
              if (responseArray[0][9] == "Mixed Feed") {
                if (responseArray[0][25] <= 45.99) {
                  Probe1TempVariant = "warning";
                } else if (responseArray[0][25] > 46) {
                  Probe1TempVariant = "danger";
                }
              }
              if (responseArray[0][9] == "Return Feed") {
                if ((responseArray[0][25] >= 48) & (responseArray[0][25] <= 49.99)) {
                  Probe1TempVariant = "warning";
                } else if (
                  (responseArray[0][25] > 37) &
                  (responseArray[0][25] <= 45.99)
                ) {
                  Probe1TempVariant = "danger";
                } else if (responseArray[0][25] > 50) {
                  Probe1TempVariant = "success";
                } else if (
                  responseArray[0][25] < 36.99 ||
                  (responseArray[0][25] >= 46) & (responseArray[0][25] <= 47.99)
                ) {
                  Probe1TempVariant = "highRisk";
                }
              }
            } else if (responseArray[0][8] == "FALSE") {
              Probe1TempVariant = "light";
              Probe1FlowVariant = "light";
            }

          let FlowDate2 = "";
          let FlowTime2 = "";
          let FlowTimeDate2 = "";
          let time2 = "";

          let Probe2TempVariant = '';
          let Probe2FlowVariant = '';

           if (responseArray[0][13] == "TRUE") {
              if (responseArray[0][30] == null || responseArray[0][31] == null) {
                time2 = "N/A";
                Probe2FlowVariant = "secondary";
              } else {
                FlowDate2 = responseArray[0][30];
                FlowTime2 = responseArray[0][31];
                FlowTimeDate2 = FlowDate2 + "T" + FlowTime2;
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate2).getTime();
                time2 = Math.floor((d1 - d2) / 1000 / 60 / 60);

              if (time2 <= 8) {
                Probe2FlowVariant = "success";
              }
              if ((time2 >= 9) & (time2 <= 24)) {
                Probe2FlowVariant = "warning";
              }
              if ((time2 >= 25) & (time2 <= 47)) {
                Probe2FlowVariant = "warning";
              }
              if (time2 >= 48) {
                Probe2FlowVariant = "danger";
              }
              }
            }


            if (responseArray[0][13] == "TRUE") {
              if (responseArray[0][14] == "Cold Feed") {
                if (responseArray[0][27] <= 19.99) {
                  Probe2TempVariant = "success";
                } else if (
                  (responseArray[0][27] > 20) &
                  (responseArray[0][27] <= 24.99)
                ) {
                  Probe2TempVariant = "warning";
                } else if (responseArray[0][27] > 30) {
                  Probe2TempVariant = "danger";
                } else if (
                  (responseArray[0][27] >= 25) &
                  (responseArray[0][27] <= 29.99)
                ) {
                  Probe2TempVariant = "highRisk";
                }
              }
              if (responseArray[0][14] == "Hot Feed") {
                if ((responseArray[0][27] <= 46) & (responseArray[0][27] > 37)) {
                  Probe2TempVariant = "danger";
                } else if (
                  (responseArray[0][27] <= 37) &
                  (responseArray[0][27] >= 30)
                ) {
                  Probe2TempVariant = "highRisk";
                } else if (
                  (responseArray[0][27] >= 45.99) &
                  (responseArray[0][27] <= 49.99)
                ) {
                  Probe2TempVariant = "highRisk";
                } else if (
                  (responseArray[0][27] > 50) &
                  (responseArray[0][27] <= 54.99)
                ) {
                  Probe2TempVariant = "warning";
                } else if (responseArray[0][27] < 29.99) {
                  Probe2TempVariant = "warning";
                } else if (responseArray[0][27] > 55) {
                  Probe2TempVariant = "success";
                }
              }
              if (responseArray[0][14] == "Mixed Feed") {
                if (responseArray[0][27] <= 45.99) {
                  Probe2TempVariant = "warning";
                } else if (responseArray[0][27] > 46) {
                  Probe2TempVariant = "danger";
                }
              }
              if (responseArray[0][14] == "Return Feed") {
                if ((responseArray[0][27] >= 48) & (responseArray[0][27] <= 49.99)) {
                  Probe2TempVariant = "warning";
                } else if (
                  (responseArray[0][27] > 37) &
                  (responseArray[0][27] <= 45.99)
                ) {
                  Probe2TempVariant = "danger";
                } else if (responseArray[0][27] > 50) {
                  Probe2TempVariant = "success";
                } else if (
                  responseArray[0][27] < 36.99 ||
                  (responseArray[0][27] >= 46) & (responseArray[0][27] <= 47.99)
                ) {
                  Probe2TempVariant = "highRisk";
                }
              }
            } else if (responseArray[0][13] == "FALSE") {
              Probe2TempVariant = "light";
              Probe2FlowVariant = "light";
            }

            let Probe1TempRnd = 0;
            let Probe1TempLimit = 0;
            let Probe1TempMin = 0;
            let Probe1ScoreVariant = '';

            if(responseArray[0][8] == "TRUE"){
              Probe1TempRnd = Math.round(responseArray[0][25]);
              Probe1TempLimit = Math.round(responseArray[0][24]);
              Probe1TempMin = Math.round(responseArray[0][11]);
            }

            let Probe2TempRnd = 0;
            let Probe2TempLimit = 0;
            let Probe2TempMin = 0;
            let Probe2ScoreVariant = '';

            if(responseArray[0][13] == "TRUE"){
              Probe2TempRnd = Math.round(responseArray[0][27]);
              Probe2TempLimit = Math.round(responseArray[0][26]);
              Probe2TempMin = Math.round(responseArray[0][16]);
              Probe2ScoreVariant = '';
            }


            let Probe1Tag = '';
            let Probe1Bio = '';
            let Probe1BioVariant = 'light';        

            if(responseArray[0][8] == "TRUE"){
              Probe1Tag = responseArray[3][0][1];
              Probe1Bio = responseArray[1][0][0];
              Probe1BioVariant = '';  
            if(responseArray[1][0][0]>=1&&(responseArray[1][0][0]<=1.49)){
              Probe1BioVariant = "success"
            } else if((responseArray[1][0][0]>=1.5) && (responseArray[1][0][0]<=2.49)){
              Probe1BioVariant = "warning"
            } else if((responseArray[1][0][0]>=2.5) && (responseArray[1][0][0]<=4)){
              Probe1BioVariant = "highRisk"
            } else if(responseArray[1][0][0]>=4.1){
              Probe1BioVariant = "danger"
            } else{
              Probe1BioVariant = 'light'
            }
          }


          let Probe2Tag = ''; 
          let Probe2Bio = '';
          let Probe2BioVariant = 'light';

           if(responseArray[0][13] == "TRUE"){
             Probe2Bio = responseArray[1][0][1];
              Probe2BioVariant = '';
              Probe2Tag = responseArray[3][1][1]
            if(responseArray[1][0][1]>=1&&(responseArray[1][0][1]<=1.49)){
              Probe2BioVariant = "success"
            } else if((responseArray[1][0][1]>=1.5) && (responseArray[1][0][1]<=2.49)){
              Probe2BioVariant = "warning"
            } else if((responseArray[1][0][1]>=2.5) && (responseArray[1][0][1]<=4)){
              Probe2BioVariant = "highRisk"
            } else if(responseArray[1][0][1]>=4.1){
              Probe2BioVariant = "danger"
            } else{
              Probe2BioVariant = 'light'
            }
          }

          if (responseArray[0][8] == "TRUE"){
            let temprisk = responseArray[4][0][0]
            if (temprisk == 'Low Risk'){
              Probe1ScoreVariant = 'success'
            } else if (temprisk == 'Moderate Risk'){
              Probe1ScoreVariant = 'warning'
            } else if(temprisk == 'High Risk'){
              Probe1ScoreVariant = 'highRisk'
            } else if(temprisk == 'Extremely High Risk'){
              Probe1ScoreVariant = 'danger'
            } else{
              Probe1ScoreVariant = 'light'
            }
          }
            
            if (responseArray[0][13] == "TRUE"){
            let temprisk = responseArray[4][0][1]
            if (temprisk == 'Low Risk'){
              Probe2ScoreVariant = 'success'
            } else if (temprisk == 'Moderate Risk'){
              Probe2ScoreVariant = 'warning'
            } else if(temprisk == 'High Risk'){
              Probe2ScoreVariant = 'highRisk'
            } else if(temprisk == 'Extremely High Risk'){
              Probe2ScoreVariant = 'danger'
            } else{
              Probe2ScoreVariant = 'light'
            }
          }

            this.c1DeviceInfo = {
              DeviceID: responseArray[0][0],
              Location: responseArray[0][2],
              Department: responseArray[0][3],
              Probe1Active: responseArray[0][8],
              Probe1Feed: responseArray[0][9],
              Probe1Position: responseArray[0][10],
              Probe1AvgTemp: responseArray[0][25],
              Probe1AvgTempRounded: Probe1TempRnd,
              Probe1TempVariant: Probe1TempVariant,
              Probe1FlowVariant: Probe1FlowVariant,
              Probe1LastFlowDate: responseArray[0][28],
              Probe1LastFlowTime: responseArray[0][29],
              Probe1TimeSinceLastFlow: time,
              Probe1ScoreVariant: Probe1ScoreVariant,
              Probe1TempLimit: Probe1TempLimit,
              Probe1TempMin: Probe1TempMin,
              Probe1BioLevel: Probe1Bio,
              Probe1BioVariant: Probe1BioVariant,
              Probe1Tag: Probe1Tag,
              Probe2Active: responseArray[0][13],
              Probe2Feed: responseArray[0][14],
              Probe2Position: responseArray[0][15],
              Probe2AvgTemp: responseArray[0][27],
              Probe2AvgTempRounded: Probe2TempRnd,
              Probe2TempVariant: Probe2TempVariant,
              Probe2FlowVariant: Probe2FlowVariant,
              Probe2TimeSinceLastFlow: time2,
              Probe2ScoreVariant: Probe2ScoreVariant,
              Probe2LastFlowDate: responseArray[0][30],
              Probe2LastFlowTime: responseArray[0][31],
              Probe2TempLimit: Probe2TempLimit,
              Probe2TempMin: Probe2TempMin,
              Probe2BioLevel: Probe2Bio,
              Probe2BioVariant: Probe2BioVariant,
              Probe2Tag: Probe2Tag,
            };
          this.deviceLocation = responseArray[0][1];
          this.devicePosition = responseArray[0][3];
          this.deviceRiskLevel = responseArray[5][0][0];
          this.GetC1Data();
        });
    } else if (this.$DetailToShow == "O-1") {
      this.DataToShow = false;
      let current = new Date();
      this.TodayDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();

      let date = new Date();
      date.setDate(date.getDate() - 1);

      let Yesterday =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

      this.ToDate = this.TodayDate;
      this.FromDate = Yesterday;
      this.deviceType = "O1";
      this.IDGetArrays(this.DeviceID, this.deviceType);
      this.SwitchToHuman("O1");

      this.loading = false;

      this.RequestGraph = false;

      // heatmapvalues
      let LookUpUrlHeatmapO1 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersHeatmapO1 = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "O1HeatmapData",
        RequestVariable: this.$DeviceID,
      };

      axios
        .post(LookUpUrlHeatmapO1, this.LookUpRequest, LookUpHeadersHeatmapO1)
        .then((response) => {
          this.heatmapvalues = response.data.HeatmapData;
        });

      let LookUpUrlO1 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let LookUpHeadersO1 = this.$apikeyPost;
      this.LookUpRequest = {
        RequestVariable: this.$DeviceID,
        Report: "O1TrendData",
        FromDate: this.FromDate,
        ToDate: this.TodayDate,
      };
      this.loaded = true;
      axios
        .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
        .then((response) => {
          // TempTable
          let O1DataList = response.data.DeviceDetails;
          let DeviceTemps = response.data.DeviceTemps;

          for (let i = 0; i < O1DataList.length; i++) {
            let Probe1TempVariant = "";
            let Probe2TempVariant = "";
            let Probe3TempVariant = "";
            let Probe4TempVariant = "";

            let Probe1FlowVariant = "";
            let Probe2FlowVariant = "";
            let Probe3FlowVariant = "";
            let Probe4FlowVariant = "";

            if (O1DataList[i][3] == "TRUE") {
              if (O1DataList[i][4] == "Cold Feed") {
                if (O1DataList[i][46] <= 19.99) {
                  Probe1TempVariant = "success";
                } else if (
                  (O1DataList[i][46] > 20) &
                  (O1DataList[i][46] <= 24.99)
                ) {
                  Probe1TempVariant = "warning";
                } else if (O1DataList[i][48] > 30) {
                  Probe1TempVariant = "danger";
                } else if (
                  (O1DataList[i][46] >= 25) &
                  (O1DataList[i][46] <= 29.99)
                ) {
                  Probe1TempVariant = "highRisk";
                }
              }
              if (O1DataList[i][4] == "Hot Feed") {
                if ((O1DataList[i][46] <= 46) & (O1DataList[i][46] > 37)) {
                  Probe1TempVariant = "danger";
                } else if (
                  (O1DataList[i][46] <= 37) &
                  (O1DataList[i][46] >= 30)
                ) {
                  Probe1TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][46] >= 45.99) &
                  (O1DataList[i][46] <= 49.99)
                ) {
                  Probe1TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][46] > 50) &
                  (O1DataList[i][46] <= 54.99)
                ) {
                  Probe1TempVariant = "warning";
                } else if (O1DataList[i][46] < 29.99) {
                  Probe1TempVariant = "warning";
                } else if (O1DataList[i][46] > 55) {
                  Probe1TempVariant = "success";
                }
              }
              if (O1DataList[i][4] == "Mixed Feed") {
                if (O1DataList[i][46] <= 45.99) {
                  Probe1TempVariant = "warning";
                } else if (O1DataList[i][46] > 46) {
                  Probe1TempVariant = "danger";
                }
              }
              if (O1DataList[i][4] == "Return Feed") {
                if ((O1DataList[i][46] >= 48) & (O1DataList[i][46] <= 49.99)) {
                  Probe1TempVariant = "warning";
                } else if (
                  (O1DataList[i][46] > 37) &
                  (O1DataList[i][46] <= 45.99)
                ) {
                  Probe1TempVariant = "danger";
                } else if (O1DataList[i][46] > 50) {
                  Probe1TempVariant = "success";
                } else if (
                  O1DataList[i][46] < 36.99 ||
                  (O1DataList[i][46] >= 46) & (O1DataList[i][46] <= 47.99)
                ) {
                  Probe1TempVariant = "highRisk";
                }
              }
            } else if (O1DataList[i][3] == "FALSE") {
              Probe1TempVariant = "light";
              Probe1FlowVariant = "light";
            }
            if (O1DataList[i][11] == "TRUE") {
              if (O1DataList[i][12] == "Cold Feed") {
                if (O1DataList[i][47] <= 19.99) {
                  Probe2TempVariant = "success";
                } else if (
                  (O1DataList[i][47] > 20) &
                  (O1DataList[i][47] <= 24.99)
                ) {
                  Probe2TempVariant = "warning";
                } else if (O1DataList[i][47] > 30) {
                  Probe2TempVariant = "danger";
                } else if (
                  (O1DataList[i][47] >= 25) &
                  (O1DataList[i][47] <= 29.99)
                ) {
                  Probe2TempVariant = "highRisk";
                }
              }
              if (O1DataList[i][12] == "Hot Feed") {
                if ((O1DataList[i][47] <= 46) & (O1DataList[i][47] > 37)) {
                  Probe2TempVariant = "danger";
                } else if (
                  (O1DataList[i][47] <= 37) &
                  (O1DataList[i][47] >= 30)
                ) {
                  Probe2TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][47] >= 45.99) &
                  (O1DataList[i][47] <= 49.99)
                ) {
                  Probe2TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][47] > 50) &
                  (O1DataList[i][47] <= 54.99)
                ) {
                  Probe2TempVariant = "warning";
                } else if (O1DataList[i][47] < 29.99) {
                  Probe2TempVariant = "warning";
                } else if (O1DataList[i][47] > 55) {
                  Probe2TempVariant = "success";
                }
              }
              if (O1DataList[i][12] == "Mixed Feed") {
                if (O1DataList[i][47] <= 45.99) {
                  Probe2TempVariant = "warning";
                } else if (O1DataList[i][47] > 46) {
                  Probe2TempVariant = "danger";
                }
              }
              if (O1DataList[i][12] == "Return Feed") {
                if ((O1DataList[i][47] >= 48) & (O1DataList[i][47] <= 49.99)) {
                  Probe2TempVariant = "warning";
                } else if (
                  (O1DataList[i][47] > 37) &
                  (O1DataList[i][47] <= 45.99)
                ) {
                  Probe2TempVariant = "danger";
                } else if (O1DataList[i][47] > 50) {
                  Probe2TempVariant = "success";
                } else if (
                  O1DataList[i][47] < 36.99 ||
                  (O1DataList[i][47] >= 46) & (O1DataList[i][47] <= 47.99)
                ) {
                  Probe2TempVariant = "highRisk";
                }
              }
            } else if (O1DataList[i][11] == "FALSE") {
              Probe2TempVariant = "light";
              Probe2FlowVariant = "light";
            }
            if (O1DataList[i][19] == "TRUE") {
              if (O1DataList[i][20] == "Cold Feed") {
                if (O1DataList[i][48] <= 19.99) {
                  Probe3TempVariant = "success";
                } else if (
                  (O1DataList[i][48] > 20) &
                  (O1DataList[i][48] <= 24.99)
                ) {
                  Probe3TempVariant = "warning";
                } else if (O1DataList[i][48] > 30) {
                  Probe3TempVariant = "danger";
                } else if (
                  (O1DataList[i][48] >= 25) &
                  (O1DataList[i][48] <= 29.99)
                ) {
                  Probe3TempVariant = "highRisk";
                }
              }
              if (O1DataList[i][20] == "Hot Feed") {
                if ((O1DataList[i][48] <= 46) & (O1DataList[i][48] > 37)) {
                  Probe3TempVariant = "danger";
                } else if (
                  (O1DataList[i][48] <= 37) &
                  (O1DataList[i][48] >= 30)
                ) {
                  Probe3TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][48] >= 45.99) &
                  (O1DataList[i][48] <= 49.99)
                ) {
                  Probe3TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][48] > 50) &
                  (O1DataList[i][48] <= 54.99)
                ) {
                  Probe3TempVariant = "warning";
                } else if (O1DataList[i][48] < 29.99) {
                  Probe3TempVariant = "warning";
                } else if (O1DataList[i][48] > 55) {
                  Probe3TempVariant = "success";
                }
              }
              if (O1DataList[i][20] == "Mixed Feed") {
                if (O1DataList[i][48] <= 45.99) {
                  Probe3TempVariant = "warning";
                } else if (O1DataList[i][48] > 46) {
                  Probe3TempVariant = "danger";
                }
              }
              if (O1DataList[i][20] == "Return Feed") {
                if ((O1DataList[i][48] >= 48) & (O1DataList[i][48] <= 49.99)) {
                  Probe3TempVariant = "warning";
                } else if (
                  (O1DataList[i][48] > 37) &
                  (O1DataList[i][48] <= 45.99)
                ) {
                  Probe3TempVariant = "danger";
                } else if (O1DataList[i][48] > 50) {
                  Probe3TempVariant = "success";
                } else if (
                  O1DataList[i][48] < 36.99 ||
                  (O1DataList[i][48] >= 46) & (O1DataList[i][48] <= 47.99)
                ) {
                  Probe3TempVariant = "highRisk";
                }
              }
            } else if (O1DataList[i][19] == "FALSE") {
              Probe3TempVariant = "light";
              Probe3FlowVariant = "light";
            }
            if (O1DataList[i][27] == "TRUE") {
              if (O1DataList[i][28] == "Cold Feed") {
                if (O1DataList[i][49] <= 19.99) {
                  Probe4TempVariant = "success";
                } else if (
                  (O1DataList[i][49] > 20) &
                  (O1DataList[i][49] <= 24.99)
                ) {
                  Probe4TempVariant = "warning";
                } else if (O1DataList[i][51] > 30) {
                  Probe4TempVariant = "danger";
                } else if (
                  (O1DataList[i][49] >= 25) &
                  (O1DataList[i][49] <= 29.99)
                ) {
                  Probe4TempVariant = "highRisk";
                }
              }
              if (O1DataList[i][28] == "Hot Feed") {
                if ((O1DataList[i][49] <= 46) & (O1DataList[i][49] > 37)) {
                  Probe4TempVariant = "danger";
                } else if (
                  (O1DataList[i][49] <= 37) &
                  (O1DataList[i][49] >= 30)
                ) {
                  Probe4TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][49] >= 45.99) &
                  (O1DataList[i][49] <= 49.99)
                ) {
                  Probe4TempVariant = "highRisk";
                } else if (
                  (O1DataList[i][49] > 50) &
                  (O1DataList[i][49] <= 54.99)
                ) {
                  Probe4TempVariant = "warning";
                } else if (O1DataList[i][49] < 29.99) {
                  Probe4TempVariant = "warning";
                } else if (O1DataList[i][49] > 55) {
                  Probe4TempVariant = "success";
                }
              }
              if (O1DataList[i][28] == "Mixed Feed") {
                if (O1DataList[i][49] <= 45.99) {
                  Probe4TempVariant = "warning";
                } else if (O1DataList[i][49] > 46) {
                  Probe4TempVariant = "danger";
                }
              }
              if (O1DataList[i][28] == "Return Feed") {
                if ((O1DataList[i][49] >= 48) & (O1DataList[i][49] <= 49.99)) {
                  Probe4TempVariant = "warning";
                } else if (
                  (O1DataList[i][49] > 37) &
                  (O1DataList[i][49] <= 45.99)
                ) {
                  Probe4TempVariant = "danger";
                } else if (O1DataList[i][49] > 50) {
                  Probe4TempVariant = "success";
                } else if (
                  O1DataList[i][49] < 36.99 ||
                  (O1DataList[i][49] >= 46) & (O1DataList[i][49] <= 47.99)
                ) {
                  Probe4TempVariant = "highRisk";
                }
              }
            } else if (O1DataList[i][27] == "FALSE") {
              Probe4TempVariant = "light";
              Probe4FlowVariant = "light";
            }

            let Probe1ScoreVariant = "";
            let Probe2ScoreVariant = "";
            let Probe3ScoreVariant = "";
            let Probe4ScoreVariant = "";

            if (O1DataList[i][3] == "TRUE") {
              if (O1DataList[i][6] < 150) {
                Probe1ScoreVariant = "danger";
              } else if ((O1DataList[i][6] < 500) & (O1DataList[i][6] >= 150)) {
                Probe1ScoreVariant = "highRisk";
              } else if ((O1DataList[i][6] >= 500) & (O1DataList[i][6] < 850)) {
                Probe1ScoreVariant = "warning";
              } else if (O1DataList[i][6] >= 850) {
                Probe1ScoreVariant = "success";
              }
            } else if (O1DataList[i][3] == "FALSE") {
              Probe1ScoreVariant = "light";
            }
            if (O1DataList[i][11] == "TRUE") {
              if (O1DataList[i][14] < 150) {
                Probe2ScoreVariant = "danger";
              } else if (
                (O1DataList[i][14] < 500) &
                (O1DataList[i][14] >= 150)
              ) {
                Probe2ScoreVariant = "highRisk";
              } else if (
                (O1DataList[i][14] >= 500) &
                (O1DataList[i][14] < 850)
              ) {
                Probe2ScoreVariant = "warning";
              } else if (O1DataList[i][14] >= 850) {
                Probe2ScoreVariant = "success";
              }
            } else if (O1DataList[i][11] == "FALSE") {
              Probe2ScoreVariant = "light";
            }
            if (O1DataList[i][19] == "TRUE") {
              if (O1DataList[i][22] < 150) {
                Probe3ScoreVariant = "danger";
              } else if (
                (O1DataList[i][22] < 500) &
                (O1DataList[i][22] >= 150)
              ) {
                Probe3ScoreVariant = "highRisk";
              } else if (
                (O1DataList[i][22] >= 500) &
                (O1DataList[i][22] < 850)
              ) {
                Probe3ScoreVariant = "warning";
              } else if (O1DataList[i][22] >= 850) {
                Probe3ScoreVariant = "success";
              }
            } else if (O1DataList[i][19] == "FALSE") {
              Probe3ScoreVariant = "light";
            }
            if (O1DataList[i][27] == "TRUE") {
              if (O1DataList[i][30] < 150) {
                Probe4ScoreVariant = "danger";
              } else if (
                (O1DataList[i][30] < 500) &
                (O1DataList[i][30] >= 150)
              ) {
                Probe4ScoreVariant = "highRisk";
              } else if (
                (O1DataList[i][30] >= 500) &
                (O1DataList[i][30] < 850)
              ) {
                Probe4ScoreVariant = "warning";
              } else if (O1DataList[i][30] >= 850) {
                Probe4ScoreVariant = "success";
              }
            } else if (O1DataList[i][27] == "FALSE") {
              Probe4ScoreVariant = "light";
            }

            if (O1DataList[i][3] == "TRUE") {
              if (O1DataList[i][9] == null || O1DataList[i][10] == null) {
                this.time = "N/A";
                Probe1FlowVariant = "secondary";
              } else {
                // PROBE 1 TIME
                let FlowTimeDate = O1DataList[i][9] + O1DataList[i][10];
                let d1 = new Date().toUTCString();
                d1 = new Date(d1).getTime();
                let d2 = new Date(FlowTimeDate).getTime();
                this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);

                if (this.time <= 2) {
                  Probe1FlowVariant = "success";
                }
                if ((this.time <= 4) & (this.time > 2)) {
                  Probe1FlowVariant = "warning";
                }
                if (this.time > 4) {
                  Probe1FlowVariant = "danger";
                }
              }
            }
            // PROBE 2 TIME
            if (O1DataList[i][11] == "TRUE") {
              if (O1DataList[i][17] == null || O1DataList[i][18] == null) {
                timeProbe2 = "N/A";
                Probe2FlowVariant = "secondary";
              } else {
                let FlowTimeDateProbe2 = O1DataList[i][17] + O1DataList[i][18];
                let d1Probe2 = new Date().toUTCString();
                d1Probe2 = new Date(d1Probe2).getTime();
                let d2Probe2 = new Date(FlowTimeDateProbe2).getTime();
                var timeProbe2 = Math.floor(
                  (d1Probe2 - d2Probe2) / 1000 / 60 / 60
                );
                if (timeProbe2 <= 2) {
                  Probe2FlowVariant = "success";
                }
                if ((timeProbe2 <= 4) & (timeProbe2 > 2)) {
                  Probe2FlowVariant = "warning";
                }
                if (timeProbe2 > 4) {
                  Probe2FlowVariant = "danger";
                }
              }
            }
            // PROBE 3 TIME
            if (O1DataList[i][19] == "TRUE") {
              if (O1DataList[i][25] == null || O1DataList[i][26] == null) {
                timeProbe3 = "N/A";
                Probe3FlowVariant = "secondary";
              } else {
                let FlowTimeDateProbe3 = O1DataList[i][25] + O1DataList[i][26];
                let d1Probe3 = new Date().toUTCString();
                d1Probe3 = new Date(d1Probe3).getTime();
                let d2Probe3 = new Date(FlowTimeDateProbe3).getTime();
                var timeProbe3 = Math.floor(
                  (d1Probe3 - d2Probe3) / 1000 / 60 / 60
                );
                if (timeProbe3 <= 2) {
                  Probe3FlowVariant = "success";
                }
                if ((timeProbe3 <= 4) & (timeProbe3 > 2)) {
                  Probe3FlowVariant = "warning";
                }
                if (timeProbe3 > 4) {
                  Probe3FlowVariant = "danger";
                }
              }
            }
            // PROBE 4 TIME
            if (O1DataList[i][27] == "TRUE") {
              if (O1DataList[i][33] == null || O1DataList[i][34] == null) {
                timeProbe4 = "N/A";
                Probe4FlowVariant = "secondary";
              } else {
                let FlowTimeDateProbe4 = O1DataList[i][33] + O1DataList[i][34];
                let d1Probe4 = new Date().toUTCString();
                d1Probe4 = new Date(d1Probe4).getTime();
                let d2Probe4 = new Date(FlowTimeDateProbe4).getTime();
                var timeProbe4 = Math.floor(
                  (d1Probe4 - d2Probe4) / 1000 / 60 / 60
                );
                if (timeProbe4 <= 2) {
                  Probe4FlowVariant = "success";
                }
                if ((timeProbe4 <= 4) & (timeProbe4 > 2)) {
                  Probe4FlowVariant = "warning";
                }
                if (timeProbe4 > 4) {
                  Probe4FlowVariant = "danger";
                }
              }
            }

            let Probe1TempRnd = Math.round(O1DataList[i][8]);
            let Probe2TempRnd = Math.round(O1DataList[i][16]);
            let Probe3TempRnd = Math.round(O1DataList[i][24]);
            let Probe4TempRnd = Math.round(O1DataList[i][32]);
            let HeaderVariant = "";

            if (O1DataList[i][38] == "Moderate Risk") {
              HeaderVariant = "warning";
            } else if (O1DataList[i][38] == "Low Risk") {
              HeaderVariant = "success";
            } else if (O1DataList[i][38] == "High Risk") {
              HeaderVariant = "highRisk";
            } else {
              HeaderVariant = "danger";
            }

            let Probe1TempLimit = Math.round(DeviceTemps[0]);
            let Probe2TempLimit = Math.round(DeviceTemps[2]);
            let Probe3TempLimit = Math.round(DeviceTemps[4]);
            let Probe4TempLimit = Math.round(DeviceTemps[6]);

            let Probe1TempMin = Math.round(DeviceTemps[1]);
            let Probe2TempMin = Math.round(DeviceTemps[3]);
            let Probe3TempMin = Math.round(DeviceTemps[5]);
            let Probe4TempMin = Math.round(DeviceTemps[7]);

            this.furtherDeviceInfo.push({
              DeviceID: O1DataList[i][0],
              Location: O1DataList[i][1],
              Department: O1DataList[i][2],
              Probe1Active: O1DataList[i][3],
              Probe1Feed: O1DataList[i][4],
              Probe1Position: O1DataList[i][5],
              Probe1Score: O1DataList[i][6],
              Probe1Offset: O1DataList[i][7],
              Probe1AvgTemp: O1DataList[i][8],
              Probe1AvgTempRounded: Probe1TempRnd,
              Probe1TempVariant: Probe1TempVariant,
              Probe1FlowVariant: Probe1FlowVariant,
              Probe1LastFlowDate: O1DataList[i][9],
              Probe1LastFlowTime: O1DataList[i][10],
              Probe1TimeSinceLastFlow: this.time,
              Probe1ScoreVariant: Probe1ScoreVariant,
              Probe1TempLimit: Probe1TempLimit,
              Probe1TempMin: Probe1TempMin,

              Probe2Active: O1DataList[i][11],
              Probe2Feed: O1DataList[i][12],
              Probe2Position: O1DataList[i][13],
              Probe2Score: O1DataList[i][14],
              Probe2Offset: O1DataList[i][15],
              Probe2AvgTemp: O1DataList[i][16],
              Probe2AvgTempRounded: Probe2TempRnd,
              Probe2TempVariant: Probe2TempVariant,
              Probe2FlowVariant: Probe2FlowVariant,
              Probe2TimeSinceLastFlow: timeProbe2,
              Probe2ScoreVariant: Probe2ScoreVariant,
              Probe2LastFlowDate: O1DataList[i][17],
              Probe2LastFlowTime: O1DataList[i][18],
              Probe2TempLimit: Probe2TempLimit,
              Probe2TempMin: Probe2TempMin,

              Probe3Active: O1DataList[i][19],
              Probe3Feed: O1DataList[i][20],
              Probe3Position: O1DataList[i][21],
              Probe3Score: O1DataList[i][22],
              Probe3Offset: O1DataList[i][23],
              Probe3AvgTemp: O1DataList[i][24],
              Probe3AvgTempRounded: Probe3TempRnd,
              Probe3TempVariant: Probe3TempVariant,
              Probe3FlowVariant: Probe3FlowVariant,
              Probe3TimeSinceLastFlow: timeProbe3,
              Probe3ScoreVariant: Probe3ScoreVariant,
              Probe3LastFlowDate: O1DataList[i][25],
              Probe3LastFlowTime: O1DataList[i][26],
              Probe3TempLimit: Probe3TempLimit,
              Probe3TempMin: Probe3TempMin,

              Probe4Active: O1DataList[i][27],
              Probe4Feed: O1DataList[i][28],
              Probe4Position: O1DataList[i][29],
              Probe4Score: O1DataList[i][30],
              Probe4Offset: O1DataList[i][31],
              Probe4AvgTemp: O1DataList[i][32],
              Probe4AvgTempRounded: Probe4TempRnd,
              Probe4TempVariant: Probe4TempVariant,
              Probe4FlowVariant: Probe4FlowVariant,
              Probe4TimeSinceLastFlow: timeProbe4,
              Probe4ScoreVariant: Probe4ScoreVariant,
              Probe4LastFlowDate: O1DataList[i][33],
              Probe4LastFlowTime: O1DataList[i][34],
              Probe4TempLimit: Probe4TempLimit,
              Probe4TempMin: Probe4TempMin,

              Recirculatory: O1DataList[i][35],
              HCEnvironment: O1DataList[i][36],
              Trending: O1DataList[i][37],
              HumanName: O1DataList[i][47],
              HeaderVariant: HeaderVariant,
            });
            this.ShowFurtherO1Detail = true;
          }

          // (this.temperatureTableHeaders = [
          //   {
          //     key: "0",
          //     label: "Time",
          //     variant: "primary",
          //     tdClass: "tableClass",
          //     thClass: "tableClass",
          //   },
          //   { key: "1", label: "Probe 1 Max" },
          //   { key: "2", label: "Probe 1 Min" },
          //   {
          //     key: "3",
          //     label: "Probe 1 Avg",
          //     tdClass: "tableClass",
          //     thClass: "tableClass",
          //   },
          //   { key: "4", label: "Probe 2 Max" },
          //   { key: "5", label: "Probe 2 Min" },
          //   {
          //     key: "6",
          //     label: "Probe 2 Avg",
          //     tdClass: "tableClass",
          //     thClass: "tableClass",
          //   },
          //   { key: "7", label: "Probe 3 Max" },
          //   { key: "8", label: "Probe 3 Min" },
          //   {
          //     key: "9",
          //     label: "Probe 3 Avg",
          //     tdClass: "tableClass",
          //     thClass: "tableClass",
          //   },
          //   { key: "10", label: "Probe 4 Max" },
          //   { key: "11", label: "Probe 4 Min" },
          //   { key: "12", label: "Probe 4 Avg" },
          // ]),
            (this.deviceLocation = response.data.Device[1]);

          this.deviceInformation = response.data.Device;

          this.deviceRiskLevel = response.data.Device[8];

          this.Score = response.data.Device[0][2];

          this.LabelDatesArray = response.data.Dates;

          this.TempTable = response.data.TempReadings;

          this.temperatureTableHeaders = [
            { key: "0", label: "Time", variant: "primary" },
            { key: "1", label: "P1Max Temp" },
            { key: "2", label: "P1Min Temp" },
            { key: "3", label: "P1Avg Temp", tdClass: "tableClass",thClass: "tableClass"},
            { key: "4", label: "P2Max Temp" },
            { key: "5", label: "P2Min Temp" },
            { key: "6", label: "P2Avg Temp", tdClass: "tableClass",thClass: "tableClass" }, 
            { key: "7", label: "P3Max Temp" },
            { key: "8", label: "P3Min Temp" },
            { key: "9", label: "P3Avg Temp", tdClass: "tableClass",thClass: "tableClass" }, 
            { key: "10", label: "P4Max Temp" },
            { key: "11", label: "P4Min Temp" },
            { key: "12", label: "P4Avg Temp", tdClass: "tableClass",thClass: "tableClass" }
           ]


          this.FlowTable = response.data.FlowReadings;

          this.flowsTableHeaders = [
            {
              key: "0",
              label: "Time",
              variant: "primary",
              tdClass: "tableClass",
              thClass: "tableClass",
            },
            {
              key: "1",
              label: "Probe 1 Flow",
              tdClass: "tableClass",
              thClass: "tableClass",
            },
            {
              key: "2",
              label: "Probe 2 Flow",
              tdClass: "tableClass",
              thClass: "tableClass",
            },
            {
              key: "3",
              label: "Probe 3 Flow",
              tdClass: "tableClass",
              thClass: "tableClass",
            },
            { key: "4", label: "Probe 4 Flow" },
          ];
          (this.O1TempOptions = {
            series: [
              {
                name: "Probe 1",
                data: response.data.DailyAvgTemps.Probe1AvgTemps,
              },
              {
                name: "Probe 2",
                data: response.data.DailyAvgTemps.Probe2AvgTemps,
              },
              {
                name: "Probe 3",
                data: response.data.DailyAvgTemps.Probe3AvgTemps,
              },
              {
                name: "Probe 4",
                data: response.data.DailyAvgTemps.Probe4AvgTemps,
              },
            ],
            chart: {
              type: "line",
              stacked: false,
              height: 350,
              zoom: {
                enabled: false,
              },
              toolbar: {
                autoSelected: "zoom",
              },
              dataLabels: {
                enabled: false,
              },
              markers: {
                size: 0,
              },

              dynamicAnimation: {
                enabled: true,
                speed: 800,
              },
            },
            title: {
              text: "Average Temperature Over Selected Dates",
              align: "left",
            },
            stroke: {
              curve: "smooth",
            },
            colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
            xaxis: {
              categories: response.data.Dates,
            },
            yaxis: {},
          }),
            (this.O1DeviceRiskLevelChart = {
              chart: {
                type: "line",
                stacked: false,
                height: 350,
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  autoSelected: "zoom",
                },
                dataLabels: {
                  enabled: false,
                },
                markers: {
                  size: 0,
                },
              },
              title: {
                text: "Device Risk Over Selected Dates",
                align: "left",
              },
              series: [
                {
                  name: "Probe 1 Risk State",
                  data: response.data.DailyStates.Probe1States,
                },
                {
                  name: "Probe 2 Risk State",
                  data: response.data.DailyStates.Probe2States,
                },
                {
                  name: "Probe 3 Risk State",
                  data: response.data.DailyStates.Probe3States,
                },
                {
                  name: "Probe 4 Risk State",
                  data: response.data.DailyStates.Probe4States,
                },
              ],
              // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
              colors: ["#d4526e","#33b2df","#f620fe","#c5ee2f"],
              xaxis: {
                categories: response.data.Dates,
              },
              yaxis: {
                min: 0,
                max: 4,
                tickAmount: 4,
                labels: {
                  show: true,
                  align: "right",
                  minWidth: 0,
                  maxWidth: 160,
                  style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    cssClass: "apexcharts-yaxis-label",
                  },
                  offsetX: 0,
                  offsetY: 0,
                  rotate: -35,
                  formatter: function(val) {
                    let RealNo = null;

                    if (val == 4) {
                      RealNo = 1;
                    } else if (val == 3) {
                      RealNo = 2;
                    } else if (val == 2) {
                      RealNo = 3;
                    } else if (val == 1) {
                      RealNo = 4;
                    } else if (val == 0) {
                      RealNo = "Stateless";
                    }

                    let labelID = "";
                    if (RealNo == 4) {
                      labelID = "Low";
                    } else if (RealNo == 3) {
                      labelID = "Moderate";
                    } else if (RealNo == 2) {
                      labelID = "High";
                    } else if (RealNo == 1) {
                      labelID = "Ext High";
                    } else if (val == 0) {
                      labelID = "Stateless";
                    }
                    return [labelID];
                    // return val;
                  },
                },
              },
            }),
            (this.O1FlowEvents = {
              // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
              colors: ["#d4526e","#33b2df","#f620fe","#c5ee2f"],
              series: [
                {
                  name: "Probe 1",
                  data: response.data.DailyFlowCounts.Probe1FlowCounts,
                },
                {
                  name: "Probe 2",
                  data: response.data.DailyFlowCounts.Probe2FlowCounts,
                },
                {
                  name: "Probe 3",
                  data: response.data.DailyFlowCounts.Probe3FlowCount,
                },
                {
                  name: "Probe 4",
                  data: response.data.DailyFlowCounts.Probe4FlowCounts,
                },
              ],
              chart: {
                type: "bar",
                height: 350,
                stacked: true,
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                  dataLabels: {
                    total: {
                      enabled: true,
                      offsetX: 0,
                      style: {
                        fontSize: "9px",
                        fontWeight: 900,
                      },
                    },
                  },
                },
              },
              stroke: {
                width: 1,
                colors: ["#fff"],
              },
              title: {
                text: "Number of Flow Events by Selected Dates ",
              },
              xaxis: {
                categories: response.data.Dates,
                labels: {
                  formatter: function(val) {
                    let rounded = Math.round(val * 10) / 10;
                    return rounded;
                  },
                },
              },
              yaxis: {
                title: {
                  text: undefined,
                },
              },

              fill: {
                opacity: 1,
              },
              legend: {
                position: "top",
                horizontalAlign: "left",
                offsetX: 40,
              },
            }),
          this.getTemperatureData(this.$DeviceID,this.FromDate,this.ToDate);
          (this.loaded = false);
          this.DataToShow = true;
        });
    } else if (this.$DetailToShow == "HW") {
      this.deviceType = "HW";
    }
  },
  methods: {
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data) {
      let ClarenceType = this.deviceType;

      if (ClarenceType == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data;
    },

    async IDGetArrays(ID, Type) {
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },

    GetTodaysDate() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      today = mm + "/" + dd + "/" + yyyy;
      return today;
    },
    onScreenResize() {
      window.addEventListener("resize", () => {
        this.updateScreenWidth();
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },

    // generateDetailedGraph() {
    //   this.RequestGraph = true;
    //   this.loading = true;
    //   let LookUpUrlO1Daily =
    //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //     this.$environment +
    //     "/s3";
    //   let LookUpHeadersO1Daily = this.$apikeyPost;
    //   this.LookUpRequest = {
    //     RequestType: "O1DailyReadingsRaw",
    //     DataDict: [
    //       {
    //         DeviceID: this.DeviceID,
    //         ReadingDate: this.DetailedDate,
    //       },
    //     ],
    //   };
    //   axios
    //     .post(LookUpUrlO1Daily, this.LookUpRequest, LookUpHeadersO1Daily)
    //     .then((response) => {
    //       this.loading = true;

    //       if (response.data.Message != null) {
    //         this.loading = false;
    //         this.DetailedTempReport = "NoData";
    //         return;
    //       }
    //       this.DetailedTempReport = "Data";
    //       let Probe1Data = [];
    //       let Probe2Data = [];
    //       let Probe3Data = [];
    //       let Probe4Data = [];
    //       for (let i = 0; i < response.data.ReadingTimes.length; i++) {
    //         if (
    //           response.data.DayData.Probe1[response.data.ReadingTimes[i]] != ""
    //         ) {
    //           Probe1Data.push(
    //             Math.round(
    //               response.data.DayData.Probe1[response.data.ReadingTimes[i]] *
    //                 100
    //             ) / 100
    //           );
    //         }
    //         if (
    //           response.data.DayData.Probe2[response.data.ReadingTimes[i]] != ""
    //         ) {
    //           Probe2Data.push(
    //             Math.round(
    //               response.data.DayData.Probe2[response.data.ReadingTimes[i]] *
    //                 100
    //             ) / 100
    //           );
    //         }
    //         if (
    //           response.data.DayData.Probe3[response.data.ReadingTimes[i]] != ""
    //         ) {
    //           Probe3Data.push(
    //             Math.round(
    //               response.data.DayData.Probe3[response.data.ReadingTimes[i]] *
    //                 100
    //             ) / 100
    //           );
    //         }
    //         if (
    //           response.data.DayData.Probe4[response.data.ReadingTimes[i]] != ""
    //         ) {
    //           Probe4Data.push(
    //             Math.round(
    //               response.data.DayData.Probe4[response.data.ReadingTimes[i]] *
    //                 100
    //             ) / 100
    //           );
    //         }
    //       }

    //       this.O1DailyTempOptions = {
    //         series: [
    //           {
    //             name: "Probe 1",
    //             data: Probe1Data,
    //           },
    //           {
    //             name: "Probe 2",
    //             data: Probe2Data,
    //           },
    //           {
    //             name: "Probe 3",
    //             data: Probe3Data,
    //           },
    //           {
    //             name: "Probe 4",
    //             data: Probe4Data,
    //           },
    //         ],
    //         chart: {
    //           type: "line",
    //           stacked: false,
    //           height: 350,
    //           zoom: {
    //             enabled: false,
    //           },
    //           toolbar: {
    //             autoSelected: "zoom",
    //           },
    //           dataLabels: {
    //             enabled: false,
    //           },
    //           markers: {
    //             size: 0,
    //           },

    //           dynamicAnimation: {
    //             enabled: true,
    //             speed: 800,
    //           },
    //         },
    //         title: {
    //           text: "Temperatures for given selected date",
    //           align: "left",
    //         },
    //         stroke: {
    //           curve: "smooth",
    //         },
    //         colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
    //         xaxis: {
    //           categories: response.data.ReadingTimes,
    //           labels: { rotate: -45 },
    //           tickAmount: 24,
    //         },
    //         yaxis: {},
    //       };
    //       this.DetailedTempReport = "Data";
    //       this.loading = false;
    //     });
    // },

    getBiofilmData(device,fromdate,todate){

      let BioLookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let BioLookUpHeadersFeed = this.$apikeyPost;
      let BioLookUpRequest = {
        RequestVariable: device,
        Report: "BiofilmDetails",
        DataDict:[
          {
            FromDate: fromdate,
            ToDate: todate,
            Type: "C1"
          }
        ]
      };
      axios
        .post(BioLookUpUrl, BioLookUpRequest, BioLookUpHeadersFeed)
        .then((response) => { 

          let Probe1vals = response.data.Values[1]
          let Probe2vals = response.data.Values[2]
          let xvals = response.data.Values[0]

          if(Probe2vals.length == 0){
            this.probe2active = false;
          }

      this.biofilmNewOptions1 = {
        series: [{
            name:"Probe1",
            data: Probe1vals
         
          }],
          chart: {
              name:'Probe1',
              id: 'Probe1',
              group: 'bioprobes',
              type: 'line',
              height: 300,
              zoom: {
            enabled: false,
          },
            },
            title: {
          text: "Biofilm Levels Over Selected Dates",
          align: "left",
        },
         yaxis: {
              title: {
                text: 'Biofilm Reading',
              },
              min: 0.0,
              max: 5.0,
              tickAmount: 5,
              decimalsInFloat: 1
            },
            tooltip: {
              enabled:true
            },
        xaxis: {
           categories: xvals,
          },
                  markers: {
              size: 3
            },
            colors: ["#d4526e"],
          legend:{
            show: true,
            showForSingleSeries: true
          }
          },
          
          this.biofilmNewOptions2 = {
            series: [{
            name:"Probe2",
            data: Probe2vals
          }],
            chart: {
              name:'Probe2',
              id: 'Probe2',
              group: 'bioprobes',
              type: 'line',
              height: 300,
              zoom: {
            enabled: false,
          },
            },
            yaxis: {
              title: {
                text: 'Biofilm Reading'
              },
              min: 0.0,
              max: 5.0,
              tickAmount: 5,
              decimalsInFloat: 1
            },
                 tooltip: {
              enabled:true
            },
             xaxis: {
           categories: xvals,
          },
          markers: {
              size: 3
            },
             
            colors: ["#33b2df"],
             legend:{
            show: true,
            showForSingleSeries: true,
          }                      
          }
           });
        },

    createC1FlowData(data,noOfProbes){
      let colourvar = [];
      let seriesvar = [];
      let flowArray1 = [];
      let flowArray2 = [];
      if(noOfProbes == 1){
        flowArray1 =  data[0]
        colourvar = ["#d4526e"],
        seriesvar = [
                {
                  name: "Probe 1",
                  data: flowArray1,
                }
                  ]
      } else{
        flowArray1 = data[0]
        flowArray2 = data[1]
        colourvar = ["#d4526e","#33b2df"],
        seriesvar = [
                {
                  name: "Probe 1",
                  data: flowArray1,
                },
                {
                  name: "Probe 2",
                  data: flowArray2,
                }
                  ]
      }
      (this.flowChartOptions = {
              colors: colourvar,
              series: seriesvar,
              chart: {
                type: "bar",
                height: 350,
                stacked:true
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                  dataLabels: {
                    total: {
                      enabled: true,
                      offsetX: 0,
                      style: {
                        fontSize: "9px",
                        fontWeight: 900,
                      },
                    },
                  },
                },
              },
              stroke: {
                width: 1,
                colors: ["#fff"],
              },
              title: {
                text: "Number of Flow Events by Selected Dates ",
              }, 
              xaxis: {
                categories: this.Dates,
                labels: {
                  formatter: function(val) {
                    let rounded = Math.round(val * 10) / 10;
                    return rounded;
                  },
                },
              },
              yaxis: {
                title: {
                  text: undefined,
                },
              },
              fill: {
                opacity: 1,
              },
              legend: {
                position: "top",
                horizontalAlign: "left",
                offsetX: 40,
              },
            })
    },
    createC1State(data,noOfProbes){
      let seriesvar = []
      let colourvar = []
      let updatesRiskStates = [];
      let updatesRiskStates2 = [];
      let FlippedStates1 = []
      let FlippedStates2 = []

      if(noOfProbes == 1){
        updatesRiskStates = data[0]

        for(let i = 0; i<updatesRiskStates.length; i++){
          let tempvar = 0
          if( updatesRiskStates[i] == 1){
            tempvar = 4
          } else if (updatesRiskStates[i] == 2){
            tempvar = 3
          } else if (updatesRiskStates[i] == 3){
            tempvar = 2
          } else if (updatesRiskStates[i] == 4){
            tempvar = 1
          }
          FlippedStates1.push(tempvar)
        }


        seriesvar =  [
                 
                {
                  name: "Probe 1 Risk State",
                  // data: updatesRiskStates
                  data: FlippedStates1
                }
                ],
        colourvar = ["#d4526e"]
          
      } else{
        updatesRiskStates = data[0]
        updatesRiskStates2 = data[1]

        for(let i = 0; i<updatesRiskStates.length; i++){
          let tempvar = 0
          if( updatesRiskStates[i] == 1){
            tempvar = 4
          } else if (updatesRiskStates[i] == 2){
            tempvar = 3
          } else if (updatesRiskStates[i] == 3){
            tempvar = 2
          } else if (updatesRiskStates[i] == 4){
            tempvar = 1
          }
          FlippedStates1.push(tempvar)
        }

        for(let v = 0; v<updatesRiskStates2.length; v++){
          let tempvar2 = 0
          if( updatesRiskStates2[v] == 1){
            tempvar2 = 4
          } else if (updatesRiskStates2[v] == 2){
            tempvar2 = 3
          } else if (updatesRiskStates2[v] == 3){
            tempvar2 = 2
          } else if (updatesRiskStates2[v] == 4){
            tempvar2 = 1
          }
          FlippedStates2.push(tempvar2)
        }

       seriesvar =  [                 
                {
                  name: "Probe 1 Risk State",
                  data: FlippedStates1
,
                },
                {
                  name: "Probe 2 Risk State",
                  data: FlippedStates2
                }
                ],
        colourvar = ["#d4526e","#33b2df"]
      }


       (this.deviceRiskChartOptions = {
                chart: {
                      type: "line",
                      stacked: false,
                      height: 350,
                      zoom: {
                        enabled: false,
                        },
                      toolbar: {
                        autoSelected: "zoom",
                      },
                      dataLabels: {
                        enabled: false,
                      },
                      markers: {
                        size: 0,
                      },
                    },
                    title: {
                      text: "Device Risk Over Selected Dates",
                      align: "left",
                    },
                series: seriesvar,
                colors: colourvar,
                xaxis: {
                  categories: this.Dates,
                },
                yaxis: {
                  min: 0,
                  max: 4,
                  tickAmount: 4,
                  labels: {
                    show: true,
                    align: "right",
                    minWidth: 0,
                    maxWidth: 160,
                    style: {
                      colors: [],
                      fontSize: "11px",
                      fontWeight: 400,
                      cssClass: "apexcharts-yaxis-label",
                    },
                    offsetX: 0,
                    offsetY: 0,
                    rotate: -35,
                    //formatter used to reverse numerical order for graph purposes
                    //this needs checked against real world values at some point, unsure if still required
                    formatter: function(val) {
                      let RealNo = null;
                      if (val == 4) {
                        RealNo = 1;
                      } else if (val == 3) {
                        RealNo = 2;
                      } else if (val == 2) {
                        RealNo = 3;
                      } else if (val == 1) {
                        RealNo = 4;
                      } else if (val == 0) {
                        RealNo = "Stateless";
                      }
                      let labelID = "";
                      if (RealNo== 4) {
                        labelID = "Low";
                      } else if (RealNo == 3) {
                        labelID = "Moderate";
                      } else if (RealNo == 2) {
                        labelID = "High";
                      } else if (RealNo == 1) {
                        labelID = "Ext High";
                      } else if (RealNo == 0) {
                        labelID = "Stateless";
                      }
                      return [labelID];
                    },
                  },
                },
              })
    },


    getTemperatureData(device,fromdate,todate){

       let TempLookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/dashboard";
      let TempLookUpHeadersFeed = this.$apikeyPost;
      let TempLookUpRequest = {
        RequestVariable: device,
        Report: "TemperatureDetails",
        DataDict:[
          {
            FromDate: fromdate,
            ToDate: todate,
            Type: this.deviceType
          }
        ]
      };
      axios
        .post(TempLookUpUrl, TempLookUpRequest, TempLookUpHeadersFeed)
        .then((response) => { 
          let responsearray = response.data.Values
          let noOfProbes = 0
          let colorvar = []
          let opacityvar = []
          let strokevar = []
          let legendvar = []
          let seriesvar = []
          let datesarray = []

          for (let a=0;a<responsearray[0].length;a++){
              datesarray.push(responsearray[0][a][0])
          }

          if(this.deviceType == 'O1'){
            for (let x=0;x<responsearray.length;x++){
              if((responsearray[x][0][1] != null)){
                noOfProbes = noOfProbes+1
              }
            }
            if(noOfProbes == 4){
              colorvar=['#d4526e','#33b2df','#f620fe','#c5ee2f','#d4526e','#33b2df','#f620fe','#c5ee2f'],
              opacityvar = [0.24,0.24,0.24,0.24,1,1,1,1],
              strokevar = [0, 0, 0, 0, 2, 2 ,2, 2],
              legendvar = ['Probe 1','Probe 2','Probe 3', 'Probe 4'],
              seriesvar = this.createTempSeries(4,responsearray) 
            } else if(noOfProbes == 3){
              colorvar=['#d4526e','#33b2df','#f620fe','#d4526e','#33b2df','#f620fe'],
              opacityvar = [0.24,0.24,0.24,1,1,1],
              strokevar = [0, 0, 0, 2 ,2, 2],
              legendvar = ['Probe 1','Probe 2', 'Probe 3'],
              seriesvar = this.createTempSeries(3,responsearray) 
            } else if(noOfProbes == 2){
              colorvar = ['#d4526e','#33b2df','#d4526e','#33b2df'],
              opacityvar = [0.24,0.24,1,1],
              strokevar = [0, 0, 2, 2],
              legendvar = ['Probe 1', 'Probe 2'],
              seriesvar = this.createTempSeries(2,responsearray)  
            } else {
              colorvar = ['#d4526e','#d4526e'],
              legendvar = ['Probe 1'],
              opacityvar = [0.24,1],
              strokevar = [0,2],
              seriesvar = this.createTempSeries(1,responsearray) 
            }
          }
          else{
            if(responsearray[1][0][3] != null && responsearray[1][0][2] != null && responsearray[1][0][1]!=null){
              noOfProbes = 2
            } else{
              noOfProbes = 1
            }
            if(noOfProbes == 2){
              colorvar = ['#d4526e','#33b2df','#d4526e','#33b2df'],
              opacityvar = [0.24,0.24,1,1],
              strokevar = [0, 0, 2, 2],
              legendvar = ['Probe 1', 'Probe 2'],
              seriesvar = this.createTempSeries(2,responsearray)
            } else {
              colorvar = ['#d4526e','#d4526e'],
              legendvar = ['Probe 1'],
              opacityvar = [0.24,1],
              strokevar = [0,2]
              seriesvar = this.createTempSeries(1,responsearray)
            }
          }
          this.tempRangeOptions= {

            series: seriesvar,
            chart: {
              height: 350,
              type: 'rangeArea',
              animations: {
                speed: 500
              }
            },
            colors: colorvar,
            dataLabels: {
              enabled: false
            },
            fill: {
              opacity: opacityvar
            },
            forecastDataPoints: {
              count: 2
            },
            stroke: {
              curve: 'straight',
              width: strokevar
            },
            legend: {
              show: true,
              customLegendItems: legendvar,
            },
            title: {
              text: 'Temperature Range'
            },
            xaxis: {
            type: "datetime",
            categories: datesarray,
            },
            yaxis:{
              min: 1,
              max:this.tempscalemax
            },
            markers: {
              hover: {
                sizeOffset: 5
              }
            }
          }
        });
    },

    createTempSeries(noOfProbes,data){

      let seriesdata = []
      if(noOfProbes == 1){
        let rangedataset1 = []
        let linedataset1 = []
        let dateset = []
        let finalrange1 = []
        let finalline1 = []

         for (let x=0;x<data[0].length;x++){
          dateset.push(data[0][x][0])
        }

        for(let y=0;y<noOfProbes;y++){
          for(let z=0;z<data[y].length;z++){
            rangedataset1.push([data[y][z][1],data[y][z][2]])
            linedataset1.push(data[y][z][3])
          }
        }
        let maxarray = []
        for(let x= 0; x<rangedataset1.length;x++){
          let tempval1 = Number(rangedataset1[x][0])
          let tempval2 = Number(rangedataset1[x][1])
          let biggest = Math.max(tempval1,tempval2)
          maxarray.push(biggest)
        }
        let maxbiggest = Math.max(...maxarray)
        maxbiggest = Math.round(maxbiggest + 10)
        this.tempscalemax = maxbiggest

        for(let v=0;v<dateset.length;v++){
          finalrange1.push(
            {
              x: dateset[v],
              y: rangedataset1[v]
            },
          )
          finalline1.push(
            {
              x:dateset[v],
              y:linedataset1[v]
            }
          )
        }

         seriesdata = [
            {
              type: 'rangeArea',
              name: 'Probe 1 Range',
              data: finalrange1
            },
             {
              type: 'line',
              name: 'Probe 1 Avg',
              data: finalline1
            }]

      } else if(noOfProbes == 2){
        let rangedataset1 = []
        let rangedataset2 = []
        let linedataset1 = []
        let linedataset2 =[]
        let dateset = []
        let finalrange1 = []
        let finalrange2 = []
        let finalline1 = []
        let finalline2 = []

        for (let x=0;x<data[0].length;x++){
          dateset.push(data[0][x][0])
        }

        for(let y=0;y<noOfProbes;y++){
          let currentPno = y+1
          for(let z=0;z<data[y].length;z++){
            if(currentPno == 1){
              rangedataset1.push([data[y][z][1],data[y][z][2]])
              linedataset1.push(data[y][z][3])
            } else{
              rangedataset2.push([data[y][z][1],data[y][z][2]])
              linedataset2.push(data[y][z][3])
            }
          }
        }

        let maxarray = []
        for(let x= 0; x<rangedataset1.length;x++){
          let tempval1 = Number(rangedataset1[x][0])
          let tempval2 = Number(rangedataset1[x][1])
          let biggest1 = Math.max(tempval1,tempval2)
          maxarray.push(biggest1)
        }

        for(let x= 0; x<rangedataset2.length;x++){
          let tempval1 = Number(rangedataset2[x][0])
          let tempval2 = Number(rangedataset2[x][1])
          let biggest2 = Math.max(tempval1,tempval2)
          maxarray.push(biggest2)
        }

        let maxbiggest = Math.max(...maxarray)
        maxbiggest = Math.round(maxbiggest + 10)
        this.tempscalemax = maxbiggest

        for(let v=0;v<dateset.length;v++){
          finalrange1.push(
            {
              x: dateset[v],
              y: rangedataset1[v]
            },
          )
          finalrange2.push(
            {
              x: dateset[v],
              y: rangedataset2[v]
            },
          )
          finalline1.push(
            {
              x:dateset[v],
              y:linedataset1[v]
            }
          )
          finalline2.push(
            {
              x:dateset[v],
              y:linedataset2[v]
            }
          )
        }
  
         seriesdata = [
            {
              type: 'rangeArea',
              name: 'Probe 1 Range',
              data: finalrange1
            },
            {
              type: 'rangeArea',
              name: 'Probe 2 Range',
              data: finalrange2
            },      
            {
              type: 'line',
              name: 'Probe 1 Avg',
              data: finalline1
            },
            {
              type: 'line',
              name: 'Probe 2 Avg',
              data: finalline2
            },
          ]

      } else if(noOfProbes == 3){

        let rangedataset1 = []
        let rangedataset2 = []
        let rangedataset3 = []
        let linedataset1 = []
        let linedataset2 = []
        let linedataset3 = []
        let dateset = []
        let finalrange1 = []
        let finalrange2 = []
        let finalrange3 = []
        let finalline1 = []
        let finalline2 = []
        let finalline3 = []

        for (let x=0;x<data[0].length;x++){
          dateset.push(data[0][x][0])
        }

        for(let y=0;y<noOfProbes;y++){
          let currentPno = y+1
          for(let z=0;z<data[y].length;z++){
            if(currentPno == 1){
              rangedataset1.push([data[y][z][1],data[y][z][2]])
              linedataset1.push(data[y][z][3])
            } else if(currentPno == 2){
              rangedataset2.push([data[y][z][1],data[y][z][2]])
              linedataset2.push(data[y][z][3])
            } else{
              rangedataset3.push([data[y][z][1],data[y][z][2]])
              linedataset3.push(data[y][z][3])
            }
          }
        }

        let maxarray = []
        for(let x= 0; x<rangedataset1.length;x++){
          let tempval1 = Number(rangedataset1[x][0])
          let tempval2 = Number(rangedataset1[x][1])
          let biggest1 = Math.max(tempval1,tempval2)
          maxarray.push(biggest1)
        }

        for(let x= 0; x<rangedataset2.length;x++){
          let tempval1 = Number(rangedataset2[x][0])
          let tempval2 = Number(rangedataset2[x][1])
          let biggest2 = Math.max(tempval1,tempval2)
          maxarray.push(biggest2)
        }

        for(let x= 0; x<rangedataset3.length;x++){
          let tempval1 = Number(rangedataset3[x][0])
          let tempval2 = Number(rangedataset3[x][1])
          let biggest3 = Math.max(tempval1,tempval2)
          maxarray.push(biggest3)
        }

        let maxbiggest = Math.max(...maxarray)
        maxbiggest = Math.round(maxbiggest + 10)
        this.tempscalemax = maxbiggest


        for(let v=0;v<dateset.length;v++){
          finalrange1.push(
            {
              x: dateset[v],
              y: rangedataset1[v]
            },
          )
          finalrange2.push(
            {
              x: dateset[v],
              y: rangedataset2[v]
            },
          )
              finalrange3.push(
            {
              x: dateset[v],
              y: rangedataset3[v]
            },
          )
          finalline1.push(
            {
              x:dateset[v],
              y:linedataset1[v]
            }
          )
          finalline2.push(
            {
              x:dateset[v],
              y:linedataset2[v]
            }
          )
          finalline3.push(
            {
              x:dateset[v],
              y:linedataset3[v]
            }
          )
        }
  
         seriesdata = [
            {
              type: 'rangeArea',
              name: 'Probe 1 Range',
              data: finalrange1
            },
            {
              type: 'rangeArea',
              name: 'Probe 2 Range',
              data: finalrange2
            },   
            {
              type: 'rangeArea',
              name: 'Probe 3 Range',
              data: finalrange3
            },     
            {
              type: 'line',
              name: 'Probe 1 Avg',
              data: finalline1
            },
            {
              type: 'line',
              name: 'Probe 2 Avg',
              data: finalline2
            },
            {
              type: 'line',
              name: 'Probe 3 Avg',
              data: finalline3
            },
          ]
      } else{

        let rangedataset1 = []
        let rangedataset2 = []
        let rangedataset3 = []
        let rangedataset4 = []
        let linedataset1 = []
        let linedataset2 = []
        let linedataset3 = []
        let linedataset4 = []
        let dateset = []
        let finalrange1 = []
        let finalrange2 = []
        let finalrange3 = []
        let finalrange4 = []
        let finalline1 = []
        let finalline2 = []
        let finalline3 = []
        let finalline4 = []

        for (let x=0;x<data[0].length;x++){
          dateset.push(data[0][x][0])
        }

        for(let y=0;y<noOfProbes;y++){
          let currentPno = y+1
          for(let z=0;z<data[y].length;z++){
            if(currentPno == 1){
              rangedataset1.push([data[y][z][1],data[y][z][2]])
              linedataset1.push(data[y][z][3])
            } else if(currentPno == 2){
              rangedataset2.push([data[y][z][1],data[y][z][2]])
              linedataset2.push(data[y][z][3])
            } else if(currentPno == 3){
              rangedataset3.push([data[y][z][1],data[y][z][2]])
              linedataset3.push(data[y][z][3])
            }else{
              rangedataset4.push([data[y][z][1],data[y][z][2]])
              linedataset4.push(data[y][z][3])
            }
          }
        }

        let maxarray = []
        for(let x= 0; x<rangedataset1.length;x++){
          let tempval1 = Number(rangedataset1[x][0])
          let tempval2 = Number(rangedataset1[x][1])
          let biggest1 = Math.max(tempval1,tempval2)
          maxarray.push(biggest1)
        }

        for(let x= 0; x<rangedataset2.length;x++){
          let tempval1 = Number(rangedataset2[x][0])
          let tempval2 = Number(rangedataset2[x][1])
          let biggest2 = Math.max(tempval1,tempval2)
          maxarray.push(biggest2)
        }

        for(let x= 0; x<rangedataset3.length;x++){
          let tempval1 = Number(rangedataset3[x][0])
          let tempval2 = Number(rangedataset3[x][1])
          let biggest3 = Math.max(tempval1,tempval2)
          maxarray.push(biggest3)
        }

        for(let x= 0; x<rangedataset4.length;x++){
          let tempval1 = Number(rangedataset4[x][0])
          let tempval2 = Number(rangedataset4[x][1])
          let biggest4 = Math.max(tempval1,tempval2)
          maxarray.push(biggest4)
        }

        let maxbiggest = Math.max(...maxarray)
        maxbiggest = Math.round(maxbiggest + 10)
        this.tempscalemax = maxbiggest



        for(let v=0;v<dateset.length;v++){
          finalrange1.push(
            {
              x: dateset[v],
              y: rangedataset1[v]
            },
          )
          finalrange2.push(
            {
              x: dateset[v],
              y: rangedataset2[v]
            },
          )
          finalrange3.push(
            {
              x: dateset[v],
              y: rangedataset3[v]
            },
          )
          finalrange4.push(
            {
              x: dateset[v],
              y: rangedataset4[v]
            },
          )
          finalline1.push(
            {
              x:dateset[v],
              y:linedataset1[v]
            }
          )
          finalline2.push(
            {
              x:dateset[v],
              y:linedataset2[v]
            }
          )
          finalline3.push(
            {
              x:dateset[v],
              y:linedataset3[v]
            }
          )
          finalline4.push(
            {
              x:dateset[v],
              y:linedataset4[v]
            }
          )
        }
  
         seriesdata = [
            {
              type: 'rangeArea',
              name: 'Probe 1 Range',
              data: finalrange1
            },
            {
              type: 'rangeArea',
              name: 'Probe 2 Range',
              data: finalrange2
            },   
            {
              type: 'rangeArea',
              name: 'Probe 3 Range',
              data: finalrange3
            },  
            {
              type: 'rangeArea',
              name: 'Probe 4 Range',
              data: finalrange4
            },    
            {
              type: 'line',
              name: 'Probe 1 Avg',
              data: finalline1
            },
            {
              type: 'line',
              name: 'Probe 2 Avg',
              data: finalline2
            },
            {
              type: 'line',
              name: 'Probe 3 Avg',
              data: finalline3
            },
            {
              type: 'line',
              name: 'Probe 4 Avg',
              data: finalline4
            },
          ]
       
      }
      return seriesdata;
    },
    resetDates: function() {


      this.DataToShow = false;

      let current = new Date();
      this.TodayDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();

      let date = new Date();
      date.setDate(date.getDate() - 1);

      let Yesterday =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

      this.ToDate = this.TodayDate;
      this.FromDate = Yesterday;
      this.submitDates();
    },

    // ShowPipeModal() {
    //   this.$refs["PipeSelectionModal"].show();
    // },
    submitDates: function() {
      // BELOW IS O1 OR C1 SELECTOR

      let date = new Date();

      let TimeBetween = new Date(this.ToDate) - new Date(this.FromDate);

      let DaysBetween = TimeBetween / (1000 * 3600 * 24);

      DaysBetween = Math.round(DaysBetween);

      if ((DaysBetween <= 31) & (!DaysBetween <= 1)) {
        if (this.$DetailToShow == "C-1") {
          this.loaded = true;
          this.DataToShow = false;

          let ID = "";
          ID = this.DeviceID;


          this.deviceType = "C1";
          // let LookUpUrl =
          //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          //   this.$environment +
          //   "/dashboard";
          // let LookUpHeadersFeed = this.$apikeyPost;
          // this.LookUpRequest = {
          //   RequestVariable: ID,
          //   Report: "C1DeviceDetail",
          // };
          // axios
          //   .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
          //   .then((response) => {

          //     this.deviceLocation = response.data.Values[0][1];
          //     this.devicePosition = response.data.Values[0][3];

          //     if (this.$DeviceVariant == "danger") {
          //       this.deviceRiskLevel = "Extremely High Risk";
          //     } else if (this.$DeviceVariant == "highRisk") {
          //       this.deviceRiskLevel = "High Risk";
          //     } else if (this.$DeviceVariant == "warning") {
          //       this.deviceRiskLevel = "Moderate Risk";
          //     } else if (this.$DeviceVariant == "success") {
          //       this.deviceRiskLevel = "Low Risk";
          //     }
          //   });

          // Current working code below, Above is a bad way to get the data for the 4 boxes at the top of the page

          let LookUpURL2 =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/dashboard";
          let LookUpHeaders2 = this.$apikeyPost;
          let LookUpData2 = {
            Report: "DeviceDetail",
            RequestVariable: ID,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          };

          axios
            .post(LookUpURL2, LookUpData2, LookUpHeaders2)
            .then((response) => {

  
              // this.Score = response.data.Device[0][2];
              // (this.responseArray = []),
              //   (this.TempArray = []),
              //   (this.LabelDatesArray = response.data.Values[0]);
              // this.GraphArray = response.data.Values[1];
              // this.TempArray = this.GraphArray[0];
              // // this.FlowArray = this.GraphArray[1];
              // this.FlowArray = [[1,2],[3,1]];
              // this.BioArray = this.GraphArray[2];
              // this.TableArray = response.data.Values;
              // this.DailyRiskState = response.data.DailyStateNumbers;
              // this.Dates = this.TableArray[0];
              // this.TempTable = response.data.Values[2];
              // this.FlowTable = response.data.Values[3];
              // this.BioTable = response.data.Values[4];
              // this.Recirculatory = response.data.Device[0][3];
              // this.RiskLevelOverTime = response.data.Values[1][2];
              // this.RiskLevels = response.data.DailyStateChanges;
              // (this.temperatureTableHeaders = [
              //   { key: "0", label: "Time", variant: "primary" },
              //   { key: "1", label: "Minimum Temp" },
              //   { key: "2", label: "Maximum Temp" },
              //   { key: "3", label: "Average Temp" },
              // ]);
                // (this.riskLevelTableData = [
                //   {
                //     DeviceID: this.DeviceID,
                //     Date: this.Dates,
                //     Time: "15:12:32",
                //     RiskLevel: this.RiskLevels,
                //   },
                // ]),
                // (this.biofilmTableData = [
                //   {
                //     DeviceID: this.DeviceID,
                //     Date: this.Dates,
                //     Time: "10:10:23",
                //     BiofilmLevel: this.BioArray,
                //   },
                // ]),
                // (this.flowsTableData = [
                //   {
                //     DeviceID: this.DeviceID,
                //     Date: this.Dates,
                //     Time: "15:28:47",
                //     Flow: true,
                //     Flows: this.FlowTable,
                //   },
                // ]);

              // let updatesRiskStates = [];
              // for (let i = 0; i < this.DailyRiskState.length; i++) {
              //   if (this.DailyRiskState[i] == "4") {
              //     updatesRiskStates.push("1");
              //   }
              //   if (this.DailyRiskState[i] == "3") {
              //     updatesRiskStates.push("2");
              //   }
              //   if (this.DailyRiskState[i] == "2") {
              //     updatesRiskStates.push("3");
              //   }
              //   if (this.DailyRiskState[i] == "1") {
              //     updatesRiskStates.push("4");
              //   }
              // }
              // let updatesRiskStates2 = [3,1];

//               (this.deviceRiskChartOptions = {
//                 chart: {
//                       type: "line",
//                       stacked: false,
//                       height: 350,
//                       zoom: {
//                         enabled: false,
//                         },
//                       toolbar: {
//                         autoSelected: "zoom",
//                       },
//                       dataLabels: {
//                         enabled: false,
//                       },
//                       markers: {
//                         size: 0,
//                       },
//                     },
//                     title: {
//                       text: "Device Risk Over Selected Dates",
//                       align: "left",
//                     },
//                 series: [
                 
//                 {
//                   name: "Probe 1 Risk State",
//                   data: updatesRiskStates
// ,
//                 },
//                 {
//                   name: "Probe 2 Risk State",
//                   data: updatesRiskStates2,
//                 },
//                 ],
//                 colors: ["#d4526e","#33b2df"],
//                 xaxis: {
//                   categories: this.Dates,
//                 },
//                 yaxis: {
//                   min: 0,
//                   max: 4,
//                   tickAmount: 4,
//                   labels: {
//                     show: true,
//                     align: "right",
//                     minWidth: 0,
//                     maxWidth: 160,
//                     style: {
//                       colors: [],
//                       fontSize: "11px",
//                       fontWeight: 400,
//                       cssClass: "apexcharts-yaxis-label",
//                     },
//                     offsetX: 0,
//                     offsetY: 0,
//                     rotate: -35,
//                     formatter: function(val) {
//                       let RealNo = null;
//                       if (val == 4) {
//                         RealNo = 1;
//                       } else if (val == 3) {
//                         RealNo = 2;
//                       } else if (val == 2) {
//                         RealNo = 3;
//                       } else if (val == 1) {
//                         RealNo = 4;
//                       } else if (val == 0) {
//                         RealNo = "Stateless";
//                       }
//                       let labelID = "";
//                       if (RealNo == 4) {
//                         labelID = "Low";
//                       } else if (RealNo == 3) {
//                         labelID = "Moderate";
//                       } else if (RealNo == 2) {
//                         labelID = "High";
//                       } else if (RealNo == 1) {
//                         labelID = "Ext High";
//                       } else if (val == 0) {
//                         labelID = "Stateless";
//                       }
//                       return [labelID];
//                     },
//                   },
//                 },
//               }),
            //     (this.flowChartOptions = {
            //   colors: ["#d4526e","#33b2df"],
            //   series: [
            //     {
            //       name: "Probe 1",
            //       data: this.FlowArray[0],
            //     },
            //     {
            //       name: "Probe 2",
            //       data: this.FlowArray[1],
            //     }
            //       ],
            //   chart: {
            //     type: "bar",
            //     height: 350,
            //     stacked:true
            //   },
            //   plotOptions: {
            //     bar: {
            //       horizontal: true,
            //       dataLabels: {
            //         total: {
            //           enabled: true,
            //           offsetX: 0,
            //           style: {
            //             fontSize: "9px",
            //             fontWeight: 900,
            //           },
            //         },
            //       },
            //     },
            //   },
            //   stroke: {
            //     width: 1,
            //     colors: ["#fff"],
            //   },
            //   title: {
            //     text: "Number of Flow Events by Selected Dates ",
            //   }, 
            //   xaxis: {
            //     categories: this.Dates,
            //     labels: {
            //       formatter: function(val) {
            //         let rounded = Math.round(val * 10) / 10;
            //         return rounded;
            //       },
            //     },
            //   },
            //   yaxis: {
            //     title: {
            //       text: undefined,
            //     },
            //   },
            //   fill: {
            //     opacity: 1,
            //   },
            //   legend: {
            //     position: "top",
            //     horizontalAlign: "left",
            //     offsetX: 40,
            //   },
            // }),
                // (this.biofilmChartOptions = {
                //   series: [
                //     {
                //       name: "Biofilm Level",
                //       data: this.BioArray,
                //     },
                //   ],
                //   chart: {
                //     type: "line",
                //     height: 350,
                //     zoom: {
                //       enabled: false,
                //     },
                //     toolbar: {
                //       autoSelected: "zoom",
                //     },
                //     dataLabels: {
                //       enabled: false,
                //     },
                //     markers: {
                //       size: 0,
                //     },
                //   },
                //   title: {
                //     text: "Biofilm Level Over Selected Dates",
                //     align: "left",
                //   },
                //   stroke: {
                //     curve: "smooth",
                //   },
                //   colors: ["#5F8575"],
                //   xaxis: {
                //     categories: this.Dates,
                //   },
                //   yaxis: {
                //     min: 1,
                //     max: 5,
                //     tickAmount: 4,
                //     labels: {
                //       formatter: function(val) {
                //         let labelID = "";
                //         if (val == 1) {
                //           labelID = "Level 1";
                //         } else if (val == 2) {
                //           labelID = "Level 2";
                //         } else if (val == 3) {
                //           labelID = "Level 3";
                //         } else if (val == 4) {
                //           labelID = "Level 4";
                //         } else if (val == 5) {
                //           labelID = "Level 5";
                //         }
                //         return [labelID];
                //       },
                //     },
                //   },
                // }),
            //     (this.chartOptions = {
            //       series: [
            //         {
            //           name: "Average (°C)",
            //           data: this.TempArray,
            //         },
            //       ],
            //       chart: {
            //         height: 350,
            //         type: "line",
            //         zoom: {
            //           enabled: false,
            //         },
            //         animations: {
            //           enabled: true,
            //           dynamicAnimation: {
            //             enabled: true,
            //             speed: 800,
            //           },
            //         },
            //       },
            //       dataLabels: {
            //         enabled: false,
            //       },
            //       stroke: {
            //         curve: "smooth",
            //       },
            //       title: {
            //         text: "Average Temperature Over Selected Dates",
            //         align: "left",
            //       },
            //       grid: {
            //         row: {
            //           colors: ["#e9ecef", "transparent"], // takes an array which will be repeated on columns
            //           opacity: 0.1,
            //         },
            //       },
            //       markers: {
            //         colors: ["#fce1e4"],
            //       },
            //       colors: ["#E97451"],
            //       xaxis: {
            //         categories: this.Dates,
            //       },
            //       yaxis: {
            //         decimalsInFloat: 1,
            //       },
            //     });
            // });
          let daysavg = response.data.Values[1]

          let flows = daysavg[1]
          let flows2 = daysavg[4]
          let FlowArray = [];
          FlowArray.push(flows)
          FlowArray.push(flows2)

          this.Score = response.data.Device[0][2];
          (this.responseArray = []),
          (this.TempArray = []),
          (this.LabelDatesArray = response.data.Values[0]);
          this.TableArray = response.data.Values;
          this.DailyRiskState = response.data.DailyStateNumbers;
          this.Dates = this.TableArray[0];
          // this.TempTable1 = response.data.Values[2];

          this.FullTemp = [];
          this.FullTemp = response.data.Values[2]


          this.FullFlow = [];

          this.FullFlow = response.data.Values[5]

          this.BioTable1 = response.data.Values[3];
          this.BioTable2 = response.data.Values[4];


          this.Recirculatory = response.data.Device[0][3];
          this.RiskLevelOverTime = response.data.Values[1][2];
          this.RiskLevels = response.data.DailyStateChanges;
          

            (this.temptablenewheaders = [
            { key: "0", label: "Time", variant: "primary" },
            { key: "1", label: "P1 Min Temp" },
            { key: "2", label: "P1 Max Temp" },
            { key: "3", label: "P1 Avg Temp", tdClass: "tableClass", thClass: "tableClass" },
            { key: "4", label: "P2 Min Temp" },
            { key: "5", label: "P2 Max Temp" },
            { key: "6", label: "P2 Avg Temp", tdClass: "tableClass", thClass: "tableClass"  },
          ]);

          let P1Active = response.data.Device[0][1]
          let P2Active = response.data.Device[0][5]
          let noOfProbes = 0;

          if(P1Active == 'TRUE' && P2Active == 'TRUE'){
            noOfProbes = 2;
          } else {
            noOfProbes = 1;
          }

          let bio1 = [];
          let bio2 = [];
          let biofull1 = [];
          let biofull2 = [];

          if(noOfProbes == 1){
            for(date in this.BioTable1){
            for(let i = 0; i<this.BioTable1[date].length;i++){
              bio1.push(this.BioTable1[date][i][1])
            let max1 = Math.max(...bio1)
            biofull1.push(max1)
            }
          }
          } else if(noOfProbes == 2){
            for(date in this.BioTable1){
            for(let i = 0; i<this.BioTable1[date].length;i++){
              bio1.push(this.BioTable1[date][i][1])
            }
            let max1 = Math.max(...bio1)
            biofull1.push(max1)
            }
            for(date in this.BioTable2){
            for(let y = 0; y<this.BioTable2[date].length;y++){
              bio2.push(this.BioTable2[date][y][1])
            }
            let max2 = Math.max(...bio2)
            biofull2.push(max2)
            }
          }

          this.BioArray = [];
          this.BioArray.push(biofull1);
          this.BioArray.push(biofull2);
          this.createC1State(this.DailyRiskState,noOfProbes)
          this.createC1FlowData(FlowArray,noOfProbes)  
          });
          this.getBiofilmData(this.$DeviceID,this.FromDate,this.ToDate);
          this.getTemperatureData(this.$DeviceID,this.FromDate,this.ToDate);
          this.loaded = false;
          this.DataToShow = true;

        } else if (this.$DetailToShow == "O-1") {
          this.loaded = true;

          this.deviceType = "O1";
          this.DataToShow = false;
          let current = new Date();
          this.TodayDate =
            current.getFullYear() +
            "-" +
            (current.getMonth() + 1) +
            "-" +
            current.getDate();

          let date = new Date();
          date.setDate(date.getDate() - 1);

          // let Yesterday =
          //   date.getFullYear() +
          //   "-" +
          //   (date.getMonth() + 1) +
          //   "-" +
          //   date.getDate();

          // this.ToDate = this.TodayDate;
          // this.FromDate = Yesterday;
          this.deviceType = "O1";

          this.loading = false;

          this.RequestGraph = false;

          let LookUpUrlO1 =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/dashboard";
          let LookUpHeadersO1 = this.$apikeyPost;
          this.LookUpRequest = {
            RequestVariable: this.$DeviceID,
            Report: "O1TrendData",
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          };
          this.loaded = true;
          axios
            .post(LookUpUrlO1, this.LookUpRequest, LookUpHeadersO1)
            .then((response) => {
              // TempTable
              let O1DataList = response.data.DeviceDetails;
              let DeviceTemps = response.data.DeviceTemps;

              for (let i = 0; i < O1DataList.length; i++) {
                let Probe1TempVariant = "";
                let Probe2TempVariant = "";
                let Probe3TempVariant = "";
                let Probe4TempVariant = "";

                let Probe1FlowVariant = "";
                let Probe2FlowVariant = "";
                let Probe3FlowVariant = "";
                let Probe4FlowVariant = "";

                if (O1DataList[i][3] == "TRUE") {
                  if (O1DataList[i][4] == "Cold Feed") {
                    if (O1DataList[i][46] <= 19.99) {
                      Probe1TempVariant = "success";
                    } else if (
                      (O1DataList[i][46] > 20) &
                      (O1DataList[i][46] <= 24.99)
                    ) {
                      Probe1TempVariant = "warning";
                    } else if (O1DataList[i][48] > 30) {
                      Probe1TempVariant = "danger";
                    } else if (
                      (O1DataList[i][46] >= 25) &
                      (O1DataList[i][46] <= 29.99)
                    ) {
                      Probe1TempVariant = "highRisk";
                    }
                  }
                  if (O1DataList[i][4] == "Hot Feed") {
                    if ((O1DataList[i][46] <= 46) & (O1DataList[i][46] > 37)) {
                      Probe1TempVariant = "danger";
                    } else if (
                      (O1DataList[i][46] <= 37) &
                      (O1DataList[i][46] >= 30)
                    ) {
                      Probe1TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][46] >= 45.99) &
                      (O1DataList[i][46] <= 49.99)
                    ) {
                      Probe1TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][46] > 50) &
                      (O1DataList[i][46] <= 54.99)
                    ) {
                      Probe1TempVariant = "warning";
                    } else if (O1DataList[i][46] < 29.99) {
                      Probe1TempVariant = "warning";
                    } else if (O1DataList[i][46] > 55) {
                      Probe1TempVariant = "success";
                    }
                  }
                  if (O1DataList[i][4] == "Mixed Feed") {
                    if (O1DataList[i][46] <= 45.99) {
                      Probe1TempVariant = "warning";
                    } else if (O1DataList[i][46] > 46) {
                      Probe1TempVariant = "danger";
                    }
                  }
                  if (O1DataList[i][4] == "Return Feed") {
                    if (
                      (O1DataList[i][46] >= 48) &
                      (O1DataList[i][46] <= 49.99)
                    ) {
                      Probe1TempVariant = "warning";
                    } else if (
                      (O1DataList[i][46] > 37) &
                      (O1DataList[i][46] <= 45.99)
                    ) {
                      Probe1TempVariant = "danger";
                    } else if (O1DataList[i][46] > 50) {
                      Probe1TempVariant = "success";
                    } else if (
                      O1DataList[i][46] < 36.99 ||
                      (O1DataList[i][46] >= 46) & (O1DataList[i][46] <= 47.99)
                    ) {
                      Probe1TempVariant = "highRisk";
                    }
                  }
                } else if (O1DataList[i][3] == "FALSE") {
                  Probe1TempVariant = "light";
                  Probe1FlowVariant = "light";
                }
                if (O1DataList[i][11] == "TRUE") {
                  if (O1DataList[i][12] == "Cold Feed") {
                    if (O1DataList[i][47] <= 19.99) {
                      Probe2TempVariant = "success";
                    } else if (
                      (O1DataList[i][47] > 20) &
                      (O1DataList[i][47] <= 24.99)
                    ) {
                      Probe2TempVariant = "warning";
                    } else if (O1DataList[i][47] > 30) {
                      Probe2TempVariant = "danger";
                    } else if (
                      (O1DataList[i][47] >= 25) &
                      (O1DataList[i][47] <= 29.99)
                    ) {
                      Probe2TempVariant = "highRisk";
                    }
                  }
                  if (O1DataList[i][12] == "Hot Feed") {
                    if ((O1DataList[i][47] <= 46) & (O1DataList[i][47] > 37)) {
                      Probe2TempVariant = "danger";
                    } else if (
                      (O1DataList[i][47] <= 37) &
                      (O1DataList[i][47] >= 30)
                    ) {
                      Probe2TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][47] >= 45.99) &
                      (O1DataList[i][47] <= 49.99)
                    ) {
                      Probe2TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][47] > 50) &
                      (O1DataList[i][47] <= 54.99)
                    ) {
                      Probe2TempVariant = "warning";
                    } else if (O1DataList[i][47] < 29.99) {
                      Probe2TempVariant = "warning";
                    } else if (O1DataList[i][47] > 55) {
                      Probe2TempVariant = "success";
                    }
                  }
                  if (O1DataList[i][12] == "Mixed Feed") {
                    if (O1DataList[i][47] <= 45.99) {
                      Probe2TempVariant = "warning";
                    } else if (O1DataList[i][47] > 46) {
                      Probe2TempVariant = "danger";
                    }
                  }
                  if (O1DataList[i][12] == "Return Feed") {
                    if (
                      (O1DataList[i][47] >= 48) &
                      (O1DataList[i][47] <= 49.99)
                    ) {
                      Probe2TempVariant = "warning";
                    } else if (
                      (O1DataList[i][47] > 37) &
                      (O1DataList[i][47] <= 45.99)
                    ) {
                      Probe2TempVariant = "danger";
                    } else if (O1DataList[i][47] > 50) {
                      Probe2TempVariant = "success";
                    } else if (
                      O1DataList[i][47] < 36.99 ||
                      (O1DataList[i][47] >= 46) & (O1DataList[i][47] <= 47.99)
                    ) {
                      Probe2TempVariant = "highRisk";
                    }
                  }
                } else if (O1DataList[i][11] == "FALSE") {
                  Probe2TempVariant = "light";
                  Probe2FlowVariant = "light";
                }
                if (O1DataList[i][19] == "TRUE") {
                  if (O1DataList[i][20] == "Cold Feed") {
                    if (O1DataList[i][48] <= 19.99) {
                      Probe3TempVariant = "success";
                    } else if (
                      (O1DataList[i][48] > 20) &
                      (O1DataList[i][48] <= 24.99)
                    ) {
                      Probe3TempVariant = "warning";
                    } else if (O1DataList[i][48] > 30) {
                      Probe3TempVariant = "danger";
                    } else if (
                      (O1DataList[i][48] >= 25) &
                      (O1DataList[i][48] <= 29.99)
                    ) {
                      Probe3TempVariant = "highRisk";
                    }
                  }
                  if (O1DataList[i][20] == "Hot Feed") {
                    if ((O1DataList[i][48] <= 46) & (O1DataList[i][48] > 37)) {
                      Probe3TempVariant = "danger";
                    } else if (
                      (O1DataList[i][48] <= 37) &
                      (O1DataList[i][48] >= 30)
                    ) {
                      Probe3TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][48] >= 45.99) &
                      (O1DataList[i][48] <= 49.99)
                    ) {
                      Probe3TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][48] > 50) &
                      (O1DataList[i][48] <= 54.99)
                    ) {
                      Probe3TempVariant = "warning";
                    } else if (O1DataList[i][48] < 29.99) {
                      Probe3TempVariant = "warning";
                    } else if (O1DataList[i][48] > 55) {
                      Probe3TempVariant = "success";
                    }
                  }
                  if (O1DataList[i][20] == "Mixed Feed") {
                    if (O1DataList[i][48] <= 45.99) {
                      Probe3TempVariant = "warning";
                    } else if (O1DataList[i][48] > 46) {
                      Probe3TempVariant = "danger";
                    }
                  }
                  if (O1DataList[i][20] == "Return Feed") {
                    if (
                      (O1DataList[i][48] >= 48) &
                      (O1DataList[i][48] <= 49.99)
                    ) {
                      Probe3TempVariant = "warning";
                    } else if (
                      (O1DataList[i][48] > 37) &
                      (O1DataList[i][48] <= 45.99)
                    ) {
                      Probe3TempVariant = "danger";
                    } else if (O1DataList[i][48] > 50) {
                      Probe3TempVariant = "success";
                    } else if (
                      O1DataList[i][48] < 36.99 ||
                      (O1DataList[i][48] >= 46) & (O1DataList[i][48] <= 47.99)
                    ) {
                      Probe3TempVariant = "highRisk";
                    }
                  }
                } else if (O1DataList[i][19] == "FALSE") {
                  Probe3TempVariant = "light";
                  Probe3FlowVariant = "light";
                }
                if (O1DataList[i][27] == "TRUE") {
                  if (O1DataList[i][28] == "Cold Feed") {
                    if (O1DataList[i][49] <= 19.99) {
                      Probe4TempVariant = "success";
                    } else if (
                      (O1DataList[i][49] > 20) &
                      (O1DataList[i][49] <= 24.99)
                    ) {
                      Probe4TempVariant = "warning";
                    } else if (O1DataList[i][51] > 30) {
                      Probe4TempVariant = "danger";
                    } else if (
                      (O1DataList[i][49] >= 25) &
                      (O1DataList[i][49] <= 29.99)
                    ) {
                      Probe4TempVariant = "highRisk";
                    }
                  }
                  if (O1DataList[i][28] == "Hot Feed") {
                    if ((O1DataList[i][49] <= 46) & (O1DataList[i][49] > 37)) {
                      Probe4TempVariant = "danger";
                    } else if (
                      (O1DataList[i][49] <= 37) &
                      (O1DataList[i][49] >= 30)
                    ) {
                      Probe4TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][49] >= 45.99) &
                      (O1DataList[i][49] <= 49.99)
                    ) {
                      Probe4TempVariant = "highRisk";
                    } else if (
                      (O1DataList[i][49] > 50) &
                      (O1DataList[i][49] <= 54.99)
                    ) {
                      Probe4TempVariant = "warning";
                    } else if (O1DataList[i][49] < 29.99) {
                      Probe4TempVariant = "warning";
                    } else if (O1DataList[i][49] > 55) {
                      Probe4TempVariant = "success";
                    }
                  }
                  if (O1DataList[i][28] == "Mixed Feed") {
                    if (O1DataList[i][49] <= 45.99) {
                      Probe4TempVariant = "warning";
                    } else if (O1DataList[i][49] > 46) {
                      Probe4TempVariant = "danger";
                    }
                  }
                  if (O1DataList[i][28] == "Return Feed") {
                    if (
                      (O1DataList[i][49] >= 48) &
                      (O1DataList[i][49] <= 49.99)
                    ) {
                      Probe4TempVariant = "warning";
                    } else if (
                      (O1DataList[i][49] > 37) &
                      (O1DataList[i][49] <= 45.99)
                    ) {
                      Probe4TempVariant = "danger";
                    } else if (O1DataList[i][49] > 50) {
                      Probe4TempVariant = "success";
                    } else if (
                      O1DataList[i][49] < 36.99 ||
                      (O1DataList[i][49] >= 46) & (O1DataList[i][49] <= 47.99)
                    ) {
                      Probe4TempVariant = "highRisk";
                    }
                  }
                } else if (O1DataList[i][27] == "FALSE") {
                  Probe4TempVariant = "light";
                  Probe4FlowVariant = "light";
                }

                let Probe1ScoreVariant = "";
                let Probe2ScoreVariant = "";
                let Probe3ScoreVariant = "";
                let Probe4ScoreVariant = "";

                if (O1DataList[i][3] == "TRUE") {
                  if (O1DataList[i][6] < 150) {
                    Probe1ScoreVariant = "danger";
                  } else if (
                    (O1DataList[i][6] < 500) &
                    (O1DataList[i][6] >= 150)
                  ) {
                    Probe1ScoreVariant = "highRisk";
                  } else if (
                    (O1DataList[i][6] >= 500) &
                    (O1DataList[i][6] < 850)
                  ) {
                    Probe1ScoreVariant = "warning";
                  } else if (O1DataList[i][6] >= 850) {
                    Probe1ScoreVariant = "success";
                  }
                } else if (O1DataList[i][3] == "FALSE") {
                  Probe1ScoreVariant = "light";
                }
                if (O1DataList[i][11] == "TRUE") {
                  if (O1DataList[i][14] < 150) {
                    Probe2ScoreVariant = "danger";
                  } else if (
                    (O1DataList[i][14] < 500) &
                    (O1DataList[i][14] >= 150)
                  ) {
                    Probe2ScoreVariant = "highRisk";
                  } else if (
                    (O1DataList[i][14] >= 500) &
                    (O1DataList[i][14] < 850)
                  ) {
                    Probe2ScoreVariant = "warning";
                  } else if (O1DataList[i][14] >= 850) {
                    Probe2ScoreVariant = "success";
                  }
                } else if (O1DataList[i][14] == "FALSE") {
                  Probe2ScoreVariant = "light";
                }
                if (O1DataList[i][19] == "TRUE") {
                  if (O1DataList[i][22] < 150) {
                    Probe3ScoreVariant = "danger";
                  } else if (
                    (O1DataList[i][22] < 500) &
                    (O1DataList[i][22] >= 150)
                  ) {
                    Probe3ScoreVariant = "highRisk";
                  } else if (
                    (O1DataList[i][22] >= 500) &
                    (O1DataList[i][22] < 850)
                  ) {
                    Probe3ScoreVariant = "warning";
                  } else if (O1DataList[i][22] >= 850) {
                    Probe3ScoreVariant = "success";
                  }
                } else if (O1DataList[i][19] == "FALSE") {
                  Probe3ScoreVariant = "light";
                }
                if (O1DataList[i][27] == "TRUE") {
                  if (O1DataList[i][30] < 150) {
                    Probe4ScoreVariant = "danger";
                  } else if (
                    (O1DataList[i][30] < 500) &
                    (O1DataList[i][30] >= 150)
                  ) {
                    Probe4ScoreVariant = "highRisk";
                  } else if (
                    (O1DataList[i][30] >= 500) &
                    (O1DataList[i][30] < 850)
                  ) {
                    Probe4ScoreVariant = "warning";
                  } else if (O1DataList[i][30] >= 850) {
                    Probe4ScoreVariant = "success";
                  }
                } else if (O1DataList[i][30] == "FALSE") {
                  Probe4ScoreVariant = "light";
                }
                if (O1DataList[i][3] == "TRUE") {
                  if (O1DataList[i][9] == null || O1DataList[i][10] == null) {
                    this.time = "N/A";
                    Probe1FlowVariant = "secondary";
                  } else {
                    // PROBE 1 TIME
                    let FlowTimeDate = O1DataList[i][9] + O1DataList[i][10];
                    let d1 = new Date().toUTCString();
                    d1 = new Date(d1).getTime();
                    let d2 = new Date(FlowTimeDate).getTime();
                    this.time = Math.floor((d1 - d2) / 1000 / 60 / 60);

                    if (this.time <= 2) {
                      Probe1FlowVariant = "success";
                    }
                    if ((this.time <= 4) & (this.time > 2)) {
                      Probe1FlowVariant = "warning";
                    }
                    if (this.time > 4) {
                      Probe1FlowVariant = "danger";
                    }
                  }
                }

                // PROBE 2 TIME
                if (O1DataList[i][11] == "TRUE") {
                  if (O1DataList[i][17] == null || O1DataList[i][18] == null) {
                    timeProbe2 = "N/A";
                    Probe2FlowVariant = "secondary";
                  } else {
                    let FlowTimeDateProbe2 =
                      O1DataList[i][17] + O1DataList[i][18];
                    let d1Probe2 = new Date().toUTCString();
                    d1Probe2 = new Date(d1Probe2).getTime();
                    let d2Probe2 = new Date(FlowTimeDateProbe2).getTime();
                    var timeProbe2 = Math.floor(
                      (d1Probe2 - d2Probe2) / 1000 / 60 / 60
                    );
                    if (timeProbe2 <= 2) {
                      Probe2FlowVariant = "success";
                    }
                    if ((timeProbe2 <= 4) & (timeProbe2 > 2)) {
                      Probe2FlowVariant = "warning";
                    }
                    if (timeProbe2 > 4) {
                      Probe2FlowVariant = "danger";
                    }
                  }
                }
                // PROBE 3 TIME
                if (O1DataList[i][19] == "TRUE") {
                  if (O1DataList[i][25] == null || O1DataList[i][26] == null) {
                    timeProbe3 = "N/A";
                    Probe3FlowVariant = "secondary";
                  } else {
                    let FlowTimeDateProbe3 =
                      O1DataList[i][25] + O1DataList[i][26];
                    let d1Probe3 = new Date().toUTCString();
                    d1Probe3 = new Date(d1Probe3).getTime();
                    let d2Probe3 = new Date(FlowTimeDateProbe3).getTime();
                    var timeProbe3 = Math.floor(
                      (d1Probe3 - d2Probe3) / 1000 / 60 / 60
                    );
                    if (timeProbe3 <= 2) {
                      Probe3FlowVariant = "success";
                    }
                    if ((timeProbe3 <= 4) & (timeProbe3 > 2)) {
                      Probe3FlowVariant = "warning";
                    }
                    if (timeProbe3 > 4) {
                      Probe3FlowVariant = "danger";
                    }
                  }
                }
                // PROBE 4 TIME
                if (O1DataList[i][27] == "TRUE") {
                  if (O1DataList[i][33] == null || O1DataList[i][34] == null) {
                    timeProbe4 = "N/A";
                    Probe4FlowVariant = "secondary";
                  } else {
                    let FlowTimeDateProbe4 =
                      O1DataList[i][33] + O1DataList[i][34];
                    let d1Probe4 = new Date().toUTCString();
                    d1Probe4 = new Date(d1Probe4).getTime();
                    let d2Probe4 = new Date(FlowTimeDateProbe4).getTime();
                    var timeProbe4 = Math.floor(
                      (d1Probe4 - d2Probe4) / 1000 / 60 / 60
                    );
                    if (timeProbe4 <= 2) {
                      Probe4FlowVariant = "success";
                    }
                    if ((timeProbe4 <= 4) & (timeProbe4 > 2)) {
                      Probe4FlowVariant = "warning";
                    }
                    if (timeProbe4 > 4) {
                      Probe4FlowVariant = "danger";
                    }
                  }
                }


                let Probe1TempRnd = Math.round(O1DataList[i][8]);
                let Probe2TempRnd = Math.round(O1DataList[i][16]);
                let Probe3TempRnd = Math.round(O1DataList[i][24]);
                let Probe4TempRnd = Math.round(O1DataList[i][32]);

                let Probe1TempLimit = Math.round(DeviceTemps[0]);
                let Probe2TempLimit = Math.round(DeviceTemps[2]);
                let Probe3TempLimit = Math.round(DeviceTemps[4]);
                let Probe4TempLimit = Math.round(DeviceTemps[6]);

                let Probe1TempMin = Math.round(DeviceTemps[1]);
                let Probe2TempMin = Math.round(DeviceTemps[3]);
                let Probe3TempMin = Math.round(DeviceTemps[5]);
                let Probe4TempMin = Math.round(DeviceTemps[7]);

     

                let HeaderVariant = "";

                if (O1DataList[i][38] == "Moderate Risk") {
                  HeaderVariant = "warning";
                } else if (O1DataList[i][38] == "Low Risk") {
                  HeaderVariant = "success";
                } else if (O1DataList[i][38] == "High Risk") {
                  HeaderVariant = "highRisk";
                } else {
                  HeaderVariant = "danger";
                }

                this.furtherDeviceInfo.push({
                  DeviceID: O1DataList[i][0],
                  Location: O1DataList[i][1],
                  Department: O1DataList[i][2],
                  Probe1Active: O1DataList[i][3],
                  Probe1Feed: O1DataList[i][4],
                  Probe1Position: O1DataList[i][5],
                  Probe1Score: O1DataList[i][6],
                  Probe1Offset: O1DataList[i][7],
                  Probe1AvgTemp: O1DataList[i][8],
                  Probe1AvgTempRounded: Probe1TempRnd,
                  Probe1TempVariant: Probe1TempVariant,
                  Probe1FlowVariant: Probe1FlowVariant,
                  Probe1LastFlowDate: O1DataList[i][9],
                  Probe1LastFlowTime: O1DataList[i][10],
                  Probe1TimeSinceLastFlow: this.time,
                  Probe1ScoreVariant: Probe1ScoreVariant,
                  Probe1TempLimit: Probe1TempLimit,
                  Probe1TempMin: Probe1TempMin,

                  Probe2Active: O1DataList[i][11],
                  Probe2Feed: O1DataList[i][12],
                  Probe2Position: O1DataList[i][13],
                  Probe2Score: O1DataList[i][14],
                  Probe2Offset: O1DataList[i][15],
                  Probe2AvgTemp: O1DataList[i][16],
                  Probe2AvgTempRounded: Probe2TempRnd,
                  Probe2TempVariant: Probe2TempVariant,
                  Probe2FlowVariant: Probe2FlowVariant,
                  Probe2TimeSinceLastFlow: timeProbe2,
                  Probe2ScoreVariant: Probe2ScoreVariant,
                  Probe2LastFlowDate: O1DataList[i][17],
                  Probe2LastFlowTime: O1DataList[i][18],
                  Probe2TempLimit: Probe2TempLimit,
                  Probe2TempMin: Probe2TempMin,

                  Probe3Active: O1DataList[i][19],
                  Probe3Feed: O1DataList[i][20],
                  Probe3Position: O1DataList[i][21],
                  Probe3Score: O1DataList[i][22],
                  Probe3Offset: O1DataList[i][23],
                  Probe3AvgTemp: O1DataList[i][24],
                  Probe3AvgTempRounded: Probe3TempRnd,
                  Probe3TempVariant: Probe3TempVariant,
                  Probe3FlowVariant: Probe3FlowVariant,
                  Probe3TimeSinceLastFlow: timeProbe3,
                  Probe3ScoreVariant: Probe3ScoreVariant,
                  Probe3LastFlowDate: O1DataList[i][25],
                  Probe3LastFlowTime: O1DataList[i][26],
                  Probe3TempLimit: Probe3TempLimit,
                  Probe3TempMin: Probe3TempMin,

                  Probe4Active: O1DataList[i][27],
                  Probe4Feed: O1DataList[i][28],
                  Probe4Position: O1DataList[i][29],
                  Probe4Score: O1DataList[i][30],
                  Probe4Offset: O1DataList[i][31],
                  Probe4AvgTemp: O1DataList[i][32],
                  Probe4AvgTempRounded: Probe4TempRnd,
                  Probe4TempVariant: Probe4TempVariant,
                  Probe4FlowVariant: Probe4FlowVariant,
                  Probe4TimeSinceLastFlow: timeProbe4,
                  Probe4ScoreVariant: Probe4ScoreVariant,
                  Probe4LastFlowDate: O1DataList[i][33],
                  Probe4LastFlowTime: O1DataList[i][34],
                  Probe4TempLimit: Probe4TempLimit,
                  Probe4TempMin: Probe4TempMin,

                  Recirculatory: O1DataList[i][35],
                  HCEnvironment: O1DataList[i][36],
                  Trending: O1DataList[i][37],
                  HumanName: O1DataList[i][47],
                  HeaderVariant: HeaderVariant,
                });
                this.ShowFurtherO1Detail = true;
              }

              // (this.temperatureTableHeaders = [
              //   {
              //     key: "0",
              //     label: "Time",
              //     variant: "primary",
              //     tdClass: "tableClass",
              //     thClass: "tableClass",
              //   },
              //   { key: "1", label: "Probe 1 Max" },
              //   { key: "2", label: "Probe 1 Min" },
              //   {
              //     key: "3",
              //     label: "Probe 1 Avg",
              //     tdClass: "tableClass",
              //     thClass: "tableClass",
              //   },
              //   { key: "4", label: "Probe 2 Max" },
              //   { key: "5", label: "Probe 2 Min" },
              //   {
              //     key: "6",
              //     label: "Probe 2 Avg",
              //     tdClass: "tableClass",
              //     thClass: "tableClass",
              //   },
              //   { key: "7", label: "Probe 3 Max" },
              //   { key: "8", label: "Probe 3 Min" },
              //   {
              //     key: "9",
              //     label: "Probe 3 Avg",
              //     tdClass: "tableClass",
              //     thClass: "tableClass",
              //   },
              //   { key: "10", label: "Probe 4 Max" },
              //   { key: "11", label: "Probe 4 Min" },
              //   { key: "12", label: "Probe 4 Avg" },
              // ]),
                (this.deviceLocation = response.data.Device[1]);

              this.deviceInformation = response.data.Device;

              this.deviceRiskLevel = response.data.Device[8];

              this.Score = response.data.Device[0][2];

              this.LabelDatesArray = response.data.Dates;

              this.TempTable = response.data.TempReadings;

              this.FlowTable = response.data.FlowReadings;

              this.flowsTableHeaders = [
                {
                  key: "0",
                  label: "Time",
                  variant: "primary",
                  tdClass: "tableClass",
                  thClass: "tableClass",
                },
                {
                  key: "1",
                  label: "Probe 1 Flow",
                  tdClass: "tableClass",
                  thClass: "tableClass",
                },
                {
                  key: "2",
                  label: "Probe 2 Flow",
                  tdClass: "tableClass",
                  thClass: "tableClass",
                },
                {
                  key: "3",
                  label: "Probe 3 Flow",
                  tdClass: "tableClass",
                  thClass: "tableClass",
                },
                { key: "4", label: "Probe 4 Flow" },
              ];
              (this.O1TempOptions = {
                series: [
                  {
                    name: "Probe 1",
                    data: response.data.DailyAvgTemps.Probe1AvgTemps,
                  },
                  {
                    name: "Probe 2",
                    data: response.data.DailyAvgTemps.Probe2AvgTemps,
                  },
                  {
                    name: "Probe 3",
                    data: response.data.DailyAvgTemps.Probe3AvgTemps,
                  },
                  {
                    name: "Probe 4",
                    data: response.data.DailyAvgTemps.Probe4AvgTemps,
                  },
                ],
                chart: {
                  type: "line",
                  stacked: false,
                  height: 350,
                  zoom: {
                    enabled: false,
                  },
                  toolbar: {
                    autoSelected: "zoom",
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  markers: {
                    size: 0,
                  },

                  dynamicAnimation: {
                    enabled: true,
                    speed: 800,
                  },
                },
                title: {
                  text: "Average Temperature Over Selected Dates",
                  align: "left",
                },
                stroke: {
                  curve: "smooth",
                },
                colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
                xaxis: {
                  categories: response.data.Dates,
                },
                yaxis: {},
              }),
                (this.O1DeviceRiskLevelChart = {
                  chart: {
                    type: "line",
                    stacked: false,
                    height: 350,
                    zoom: {
                      enabled: false,
                    },
                    toolbar: {
                      autoSelected: "zoom",
                    },
                    dataLabels: {
                      enabled: false,
                    },
                    markers: {
                      size: 0,
                    },
                  },
                  title: {
                    text: "Device Risk Over Selected Dates",
                    align: "left",
                  },
                  series: [
                    {
                      name: "Probe 1 Risk State",
                      data: response.data.DailyStates.Probe1States,
                    },
                    {
                      name: "Probe 2 Risk State",
                      data: response.data.DailyStates.Probe2States,
                    },
                    {
                      name: "Probe 3 Risk State",
                      data: response.data.DailyStates.Probe3States,
                    },
                    {
                      name: "Probe 4 Risk State",
                      data: response.data.DailyStates.Probe4States,
                    },
                  ],
                  // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
                  colors: ["#d4526e","#33b2df","#f620fe","#c5ee2f"],
                  xaxis: {
                    categories: response.data.Dates,
                  },
                  yaxis: {
                    min: 0,
                    max: 4,
                    tickAmount: 4,
                    labels: {
                      show: true,
                      align: "right",
                      minWidth: 0,
                      maxWidth: 160,
                      style: {
                        colors: [],
                        fontSize: "11px",
                        fontWeight: 400,
                        cssClass: "apexcharts-yaxis-label",
                      },
                      offsetX: 0,
                      offsetY: 0,
                      rotate: -35,
                      formatter: function(val) {
                        let RealNo = null;

                        if (val == 4) {
                          RealNo = 1;
                        } else if (val == 3) {
                          RealNo = 2;
                        } else if (val == 2) {
                          RealNo = 3;
                        } else if (val == 1) {
                          RealNo = 4;
                        } else if (val == 0) {
                          RealNo = "Stateless";
                        }

                        let labelID = "";
                        if (RealNo == 4) {
                          labelID = "Low";
                        } else if (RealNo == 3) {
                          labelID = "Moderate";
                        } else if (RealNo == 2) {
                          labelID = "High";
                        } else if (RealNo == 1) {
                          labelID = "Ext High";
                        } else if (val == 0) {
                          labelID = "Stateless";
                        }
                        return [labelID];
                      },
                    },
                  },
                }),
                (this.O1FlowEvents = {
                  // colors: ["#008080", "#FF00FF", "#f4c430", "#7fff00"],
                  colors: ["#d4526e","#33b2df","#f620fe","#c5ee2f"],
                  series: [
                    {
                      name: "Probe 1",
                      data: response.data.DailyFlowCounts.Probe1FlowCounts,
                    },
                    {
                      name: "Probe 2",
                      data: response.data.DailyFlowCounts.Probe2FlowCounts,
                    },
                    {
                      name: "Probe 3",
                      data: response.data.DailyFlowCounts.Probe3FlowCount,
                    },
                    {
                      name: "Probe 4",
                      data: response.data.DailyFlowCounts.Probe4FlowCounts,
                    },
                  ],
                  chart: {
                    type: "bar",
                    height: 350,
                    stacked: true,
                  },
                  plotOptions: {
                    bar: {
                      horizontal: true,
                      dataLabels: {
                        total: {
                          enabled: true,
                          offsetX: 0,
                          style: {
                            fontSize: "9px",
                            fontWeight: 900,
                          },
                        },
                      },
                    },
                  },
                  stroke: {
                    width: 1,
                    colors: ["#fff"],
                  },
                  title: {
                    text: "Number of Flow Events by Selected Dates ",
                  },
                  xaxis: {
                    categories: response.data.Dates,
                    labels: {
                      formatter: function(val) {
                        let rounded = Math.round(val * 10) / 10;
                        return rounded;
                      },
                    },
                  },
                  yaxis: {
                    title: {
                      text: undefined,
                    },
                  },

                  fill: {
                    opacity: 1,
                  },
                  legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 40,
                  },
                }),
                this.getBiofilmData(this.$DeviceID,this.FromDate,this.ToDate);
                this.getTemperatureData(this.$DeviceID,this.FromDate,this.ToDate);
                (this.loaded = false);
              this.DataToShow = true;
            });
        }
      } else {
        alert("Please ensure dates are within 31 days of each other");
      }
    },
    downloadCSV(tableID, filename) {
      // LabelDatesArray loop over this
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableHTML = "";
      for (let i = 0; i < this.LabelDatesArray.length; i++) {
        var tableDate = this.LabelDatesArray[i];

        var tableSelect = document.getElementById("tempTable" + i);
        var tableSelect1 = document.getElementById("flowsTable" + i);
        var BR = document.getElementById("excelBR");
        tableHTML =
          tableHTML +
          tableDate +
          BR.outerHTML.replace(/ /g, "%20") +
          BR.outerHTML.replace(/ /g, "%20") +
          "Temperature (C)" +
          tableSelect.outerHTML.replace(/ /g, "%20") +
          BR.outerHTML.replace(/ /g, "%20") +
          "Flows" +
          tableSelect1.outerHTML.replace(/ /g, "%20") +
          BR.outerHTML.replace(/ /g, "%20");
      }

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        (downloadLink.href = "data:" + dataType + ", " + tableHTML),
          // Setting the file name
          (downloadLink.download = filename);
        //triggering the function
        downloadLink.click();
      }
    },
    logout() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });
      /*  let UserName=this.profile.name; */
      let UserPortal = this.$ProfilePortal;
      let UserURN = this.$UserURN;

      let EventHistory = "Logged Out";

      axios.get("https://www.cloudflare.com/cdn-cgi/trace").then((response) => {
        this.response = response.data;
        let UserIPAddress = this.response.substring(
          this.response.search("ip=") + 3,
          this.response.search("ts=") - 1
        );
        let sendUrl =
          "https://bg4rfm4uqd.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userhistory";

        let sendData = {
          UserURN: UserURN,
          UserIPAddress: UserIPAddress,
          HistoryDate: HistoryDate,
          HistoryTime: HistoryTime,
          HistoryNote: EventHistory,
          ProfilePortal: UserPortal,
        };
        let sendHeaders = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": "WEqEfodYfW3cSpQ99TGlD3pJFCbB0KAG6byvLEpm",
          },
        };
        axios
          .post(sendUrl, sendData, sendHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => "error: " + err);
      });

      this.$auth.logout();
    },

    selectedDeviceType() {
      this.selectDeviceType = "";
      if (this.selectedDeviceType == "C1") {
        this.selectDeviceType = "C1";
      }
    },
    backButton() {
      history.back();
    },
    clearChart() {
      (this.DetailedDate = ""), (this.S3ImageURL = "");
    },
    // NewChartTest(){
    //   if (this.DetailedDate == "") {
    //      alert("Please select a date");
    //    } else {
    //   alert("generate a new chart: " + this.DeviceID)
    //   let LookUpUrlDailyO1 =
    //         "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //         this.$environment +
    //         "/dashboard";
    //       let LookUpHeadersDailyO1 = this.$apikeyPost;
    //       let LookUpDailyO1Request = {
    //         Report: "TempGraph24hr",
    //         RequestVariable: this.$DeviceID,
    //         FromDate: this.DetailedDate,
    //         ToDate: this.DetailedDate,
    //       };
    //       this.loaded = true;

    //       console.log(LookUpUrlDailyO1)
    //       console.log(LookUpHeadersDailyO1)
    //       console.log(LookUpDailyO1Request)

          // axios
          //   .post(LookUpUrlDailyO1, LookUpDailyO1Request, LookUpHeadersDailyO1)
          //   .then((response) => {
          //     console.log(response)
          //   });
 
    // }
  // },
    // getChartPreSignedURL() {
    //   if (this.DetailedDate == "") {
    //     alert("Please select a date");
    //   } else {
    //     let Bucket = "";
    //     if (this.deviceType == "O1") {
    //       // PROD - dronedevicedata
    //       // DEV - o1testbucket
    //       if (this.$environment == "PROD") {
    //         Bucket = "dronedevicedata";
    //       }
    //       if (this.$environment == "DEV") {
    //         Bucket = "o1testbucket";
    //       }
    //     }

    //     if (this.deviceType == "C1") {
    //       // PROD - clarencedevicedata
    //       // DEV - clarencetestbucket
    //       if (this.$environment == "PROD") {
    //         Bucket = "clarencedevicedata";
    //       }
    //       if (this.$environment == "DEV") {
    //         Bucket = "clarencetestbucket";
    //       }
    //     }

    //     let S3ImageLookupURL =
    //       "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //       this.$environment +
    //       "/s3";
    //     let S3ImageLookupHeaders = this.$apikeyPost;
    //     let S3ImageLookupRequest = {
    //       RequestType: "GeneratePreSignedURL",
    //       DataDict: [
    //         {
    //           Bucket: Bucket,
    //           DeviceID: this.DeviceID,
    //           Date: this.DetailedDate,
    //         },
    //       ],
    //     };
    //     axios
    //       .post(S3ImageLookupURL, S3ImageLookupRequest, S3ImageLookupHeaders)
    //       .then((response) => {
    //         this.S3ImageURL = response.data.Values;
    //       });
    //   }
    // },

    // PipeConfirmed() {
    //   if (this.PipeToShow != "") {
    //     this.PipeSelected = true;
    //     this.GetC1Data();
    //   } else {
    //     this.PipeSelected = false;
    //   }
    //   this.$refs["PipeSelectionModal"].hide();
    // },

    GetC1Data() {
      // if (this.IfMultipipe == true && this.PipeSelected == false) {
      //   this.responseArray = [];
      //   this.TempArray = [];
      //   this.$refs["PipeSelectionModal"].show();
      // }
      // if (this.IfMultipipe == true && this.PipeSelected == true) {
      //   this.$refs["PipeSelectionModal"].hide();
      //   //New code
      //   this.DeviceID = this.DeviceID.substring(0, this.DeviceID.length - 1) + this.PipeToShow;
      //   //
      //   this.DataToShow = false;
      //   let current = new Date();
      //   this.TodayDate =
      //     current.getFullYear() +
      //     "-" +
      //     (current.getMonth() + 1) +
      //     "-" +
      //     current.getDate();

      //   let date = new Date();
      //   date.setDate(date.getDate() - 1);

      //   let Yesterday =
      //     date.getFullYear() +
      //     "-" +
      //     (date.getMonth() + 1) +
      //     "-" +
      //     date.getDate();

      //   this.ToDate = this.TodayDate;
      //   this.FromDate = Yesterday;

      //   let LookUpUrlHeatmapO1 =
      //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //     this.$environment +
      //     "/dashboard";
      //   let LookUpHeadersHeatmapO1 = this.$apikeyPost;
      //   this.LookUpRequest = {
      //     Report: "C1HeatmapData",
      //     RequestVariable: this.DeviceID
      //   };

      //   axios
      //     .post(LookUpUrlHeatmapO1, this.LookUpRequest, LookUpHeadersHeatmapO1)
      //     .then((response) => {
      //       this.heatmapvalues = response.data.HeatmapData;
      //     });

      //   let LookUpURL2 =
      //     "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      //     this.$environment +
      //     "/dashboard";
      //   let LookUpHeaders2 = this.$apikeyPost;
      //   let LookUpData2 = {
      //     Report: "DeviceDetail",
      //     RequestVariable: this.DeviceID,
      //     FromDate: this.FromDate,
      //     ToDate: this.TodayDate,
      //   };


      //   this.loaded = true;

      //   axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {

      //     this.Score = response.data.Device[0][2];
      //     (this.responseArray = []),
      //       (this.TempArray = []),
      //       (this.LabelDatesArray = response.data.Values[0]);
      //     this.GraphArray = response.data.Values[1];
      //     this.TempArray = this.GraphArray[0];
      //     this.FlowArray = this.GraphArray[1];
      //     this.BioArray = this.GraphArray[2];
      //     this.TableArray = response.data.Values;
      //     this.DailyRiskState = response.data.DailyStateNumbers;
      //     this.Dates = this.TableArray[0];
      //     this.TempTable = response.data.Values[2];
      //     this.FlowTable = response.data.Values[3];
      //     this.BioTable = response.data.Values[4];
      //     this.Recirculatory = response.data.Device[0][3];
      //     this.RiskLevelOverTime = response.data.Values[1][2];
      //     this.RiskLevels = response.data.DailyStateChanges;
      //       (this.riskLevelTableData = [
      //         {
      //           DeviceID: this.DeviceID,
      //           Date: this.Dates,
      //           Time: "15:12:32",
      //           RiskLevel: this.RiskLevels,
      //         },
      //       ]),
      //       (this.biofilmTableData = [
      //         {
      //           DeviceID: this.DeviceID,
      //           Date: this.Dates,
      //           Time: "10:10:23",
      //           BiofilmLevel: this.BioArray,
      //         },
      //       ]),
      //       (this.flowsTableData = [
      //         {
      //           DeviceID: this.DeviceID,
      //           Date: this.Dates,
      //           Time: "15:28:47",
      //           Flow: true,
      //           Flows: this.FlowTable,
      //         },
      //       ]);

      //     let updatesRiskStates = [];
      //     for (let i = 0; i < this.DailyRiskState.length; i++) {
      //       if (this.DailyRiskState[i] == "4") {
      //         updatesRiskStates.push("1");
      //       }
      //       if (this.DailyRiskState[i] == "3") {
      //         updatesRiskStates.push("2");
      //       }
      //       if (this.DailyRiskState[i] == "2") {
      //         updatesRiskStates.push("3");
      //       }
      //       if (this.DailyRiskState[i] == "1") {
      //         updatesRiskStates.push("4");
      //       }
      //     }

      //     (this.deviceRiskChartOptions = {
      //       series: [
      //         {
      //           name: "Risk State",
      //           data: updatesRiskStates,
      //         },
      //       ],

      //       chart: {
      //         type: "line",
      //         stacked: false,
      //         height: 350,
      //         zoom: {
      //           enabled: false,
      //         },
      //         toolbar: {
      //           autoSelected: "zoom",
      //         },
      //         dataLabels: {
      //           enabled: false,
      //         },
      //         markers: {
      //           size: 0,
      //         },
      //       },
      //       title: {
      //         text: "Device Risk Over Selected Dates",
      //         align: "left",
      //       },

      //       colors: ["#bb9bf2"],
      //       xaxis: {
      //         categories: this.Dates,
      //       },
      //       yaxis: {
      //         min: 0,
      //         max: 4,
      //         tickAmount: 4,
      //         labels: {
      //           show: true,
      //           align: "right",
      //           minWidth: 0,
      //           maxWidth: 160,
      //           style: {
      //             colors: [],
      //             fontSize: "11px",
      //             fontWeight: 400,
      //             cssClass: "apexcharts-yaxis-label",
      //           },
      //           offsetX: 0,
      //           offsetY: 0,
      //           rotate: -35,
      //           formatter: function(val) {
      //             let RealNo = null;

      //             if (val == 4) {
      //               RealNo = 1;
      //             } else if (val == 3) {
      //               RealNo = 2;
      //             } else if (val == 2) {
      //               RealNo = 3;
      //             } else if (val == 1) {
      //               RealNo = 4;
      //             } else if (val == 0) {
      //               RealNo = "Stateless";
      //             }

      //             let labelID = "";
      //             if (RealNo == 4) {
      //               labelID = "Low";
      //             } else if (RealNo == 3) {
      //               labelID = "Moderate";
      //             } else if (RealNo == 2) {
      //               labelID = "High";
      //             } else if (RealNo == 1) {
      //               labelID = "Ext High";
      //             } else if (val == 0) {
      //               labelID = "Stateless";
      //             }
      //             return [labelID];
      //           },
      //         },
      //       },
      //     }),
      //       (this.flowChartOptions = {
      //         series: [
      //           {
      //             name: "No. of Flow Events",
      //             data: this.FlowArray,
      //           },
      //         ],
      //         chart: {
      //           type: "bar",
      //           height: 350,
      //         },
      //         title: {
      //           text: "Number of Flow Events by Selected Dates",
      //           align: "left",
      //         },
      //         plotOptions: {
      //           bar: {
      //             borderRadius: 4,
      //             horizontal: true,
      //           },
      //           dataLabels: {
      //             enabled: false,
      //           },
      //         },
      //         xaxis: {
      //           categories: this.Dates,
      //         },
      //       }),
      //       (this.biofilmChartOptions = {
      //         series: [
      //           {
      //             name: "Biofilm Level",
      //             data: this.BioArray,
      //           },
      //         ],
      //         chart: {
      //           type: "line",
      //           height: 350,
      //           zoom: {
      //             enabled: false,
      //           },
      //           toolbar: {
      //             autoSelected: "zoom",
      //           },
      //           dataLabels: {
      //             enabled: false,
      //           },
      //           markers: {
      //             size: 0,
      //           },
      //         },
      //         title: {
      //           text: "Biofilm Level Over Selected Dates",
      //           align: "left",
      //         },
      //         stroke: {
      //           curve: "smooth",
      //         },
      //         colors: ["#5F8575"],
      //         xaxis: {
      //           categories: this.Dates,
      //         },
      //         yaxis: {
      //           min: 1,
      //           max: 5,
      //           tickAmount: 4,
      //           labels: {
      //             formatter: function(val) {
      //               let labelID = "";
      //               if (val == 1) {
      //                 labelID = "Level 1";
      //               } else if (val == 2) {
      //                 labelID = "Level 2";
      //               } else if (val == 3) {
      //                 labelID = "Level 3";
      //               } else if (val == 4) {
      //                 labelID = "Level 4";
      //               } else if (val == 5) {
      //                 labelID = "Level 5";
      //               }
      //               return [labelID];
      //             },
      //           },
      //         },
      //       }),
      //       (this.chartOptions = {
      //         series: [
      //           {
      //             name: "Average (°C)",
      //             data: this.TempArray,
      //           },
      //         ],
      //         chart: {
      //           height: 350,
      //           type: "line",
      //           zoom: {
      //             enabled: false,
      //           },
      //           animations: {
      //             enabled: true,
      //             dynamicAnimation: {
      //               enabled: true,
      //               speed: 800,
      //             },
      //           },
      //         },
      //         dataLabels: {
      //           enabled: false,
      //         },
      //         stroke: {
      //           curve: "smooth",
      //         },
      //         title: {
      //           text: "Average Temperature Over Selected Dates",
      //           align: "left",
      //         },
      //         grid: {
      //           row: {
      //             colors: ["#e9ecef", "transparent"], // takes an array which will be repeated on columns
      //             opacity: 0.1,
      //           },
      //         },
      //         markers: {
      //           colors: ["#fce1e4"],
      //         },
      //         colors: ["#E97451"],
      //         xaxis: {
      //           categories: this.Dates,
      //         },
      //         yaxis: {
      //           decimalsInFloat: 1,
      //         },
      //       });

      //     this.loaded = false;
      //     this.DataToShow = true;
      //   });
      // } else if (this.IfMultipipe == false) {
        let LookUpUrlHeatmapO1 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeadersHeatmapO1 = this.$apikeyPost;
        this.LookUpRequest = {
          Report: "C1HeatmapData",
          RequestVariable: this.$DeviceID,
        };

        axios
          .post(LookUpUrlHeatmapO1, this.LookUpRequest, LookUpHeadersHeatmapO1)
          .then((response) => {
            this.heatmapvalues = response.data.HeatmapData;
          });
        let current = new Date();
        this.TodayDate =
          current.getFullYear() +
          "-" +
          (current.getMonth() + 1) +
          "-" +
          current.getDate();

        let date = new Date();
        date.setDate(date.getDate() - 1);

        let Yesterday =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate();

        this.ToDate = this.TodayDate;
        this.FromDate = Yesterday;

        let LookUpURL2 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/dashboard";
        let LookUpHeaders2 = this.$apikeyPost;
        let LookUpData2 = {
          Report: "DeviceDetail",
          RequestVariable: this.DeviceID,
          FromDate: this.FromDate,
          ToDate: this.TodayDate,
        };
        this.DataToShow = false;
        this.loaded = true;

        axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {

          let daysavg = response.data.Values[1]

          let flows = daysavg[1]
          let flows2 = daysavg[4]
          let FlowArray = [];
          FlowArray.push(flows)
          FlowArray.push(flows2)

          this.Score = response.data.Device[0][2];
          (this.responseArray = []),
          (this.TempArray = []),
          (this.LabelDatesArray = response.data.Values[0]);
          this.TableArray = response.data.Values;
          this.DailyRiskState = response.data.DailyStateNumbers;
          this.Dates = this.TableArray[0];
          // this.TempTable1 = response.data.Values[2];

          this.FullTemp = [];
          this.FullTemp = response.data.Values[2]


          this.FullFlow = [];

          this.FullFlow = response.data.Values[5]

          this.BioTable1 = response.data.Values[3];
          this.BioTable2 = response.data.Values[4];


          this.Recirculatory = response.data.Device[0][3];
          this.RiskLevelOverTime = response.data.Values[1][2];
          this.RiskLevels = response.data.DailyStateChanges;
          

            (this.temptablenewheaders = [
            { key: "0", label: "Time", variant: "primary" },
            { key: "1", label: "P1 Min Temp" },
            { key: "2", label: "P1 Max Temp" },
            { key: "3", label: "P1 Avg Temp", tdClass: "tableClass", thClass: "tableClass" },
            { key: "4", label: "P2 Min Temp" },
            { key: "5", label: "P2 Max Temp" },
            { key: "6", label: "P2 Avg Temp", tdClass: "tableClass", thClass: "tableClass"  },
          ]);

          let P1Active = response.data.Device[0][1]
          let P2Active = response.data.Device[0][5]
          let noOfProbes = 0;

          if(P1Active == 'TRUE' && P2Active == 'TRUE'){
            noOfProbes = 2;
          } else {
            noOfProbes = 1;
          }

          let bio1 = [];
          let bio2 = [];
          let biofull1 = [];
          let biofull2 = [];

          if(noOfProbes == 1){
            for(date in this.BioTable1){
            for(let i = 0; i<this.BioTable1[date].length;i++){
              bio1.push(this.BioTable1[date][i][1])
            let max1 = Math.max(...bio1)
            biofull1.push(max1)
            }
          }
          } else if(noOfProbes == 2){
            for(date in this.BioTable1){
            for(let i = 0; i<this.BioTable1[date].length;i++){
              bio1.push(this.BioTable1[date][i][1])
            }
            let max1 = Math.max(...bio1)
            biofull1.push(max1)
            }
            for(date in this.BioTable2){
            for(let y = 0; y<this.BioTable2[date].length;y++){
              bio2.push(this.BioTable2[date][y][1])
            }
            let max2 = Math.max(...bio2)
            biofull2.push(max2)
            }
          }

          this.BioArray = [];
          this.BioArray.push(biofull1);
          this.BioArray.push(biofull2);

          this.createC1State(this.DailyRiskState,noOfProbes)
          this.createC1FlowData(FlowArray,noOfProbes)
          this.getBiofilmData(this.$DeviceID,this.FromDate,this.ToDate)
          this.getTemperatureData(this.$DeviceID,this.FromDate,this.ToDate);
          this.loaded = false;
          this.DataToShow = true;
        });
      },
    
    },
  
  watch: {
    // O1Array() {
    //   this.$nextTick().then(this.testFunction());
    // },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}

.accessDeniedDiv {
  background-color: red;
}
.accessDenied {
  color: white;
  margin-top: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
h1 {
  color: white;
}
.returnLink {
  text-align: left;
  text-decoration: underline;
  font-weight: 500;
  position: absolute;
  margin-top: 2.5%;
  padding-left: 1rem;
  margin-left: -15px;
}
.headerText {
  font-weight: 650;
}
.centered {
  text-align: center;
}
.tableClass {
  border-right: 2px solid black;
}
thead th {
      font-size: 12px !important;

 }
.NoCardBorder {
  border: 0px solid rgb(0, 0, 0);
}
.success {
  background-color: #28a745;
}
.warning {
  background-color: #ffc107;
  color: #000000;
}
.danger {
  background-color: #dc3545;
}

.light {
  background-color: #f8f9fa;
  color: #000000;
}
.highRisk {
  background-color: #f05e16;
  color: #000;
}
</style>
